(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb612"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb612"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7EHRQ", function(module, exports) {

var $2PJNN = parcelRequire("2PJNN");

var $7xDhZ = parcelRequire("7xDhZ");

var $1OMRv = parcelRequire("1OMRv");

var $39i23 = parcelRequire("39i23");

var $FPA49 = parcelRequire("FPA49");

var $jPFnF = parcelRequire("jPFnF");

var $cixNf = parcelRequire("cixNf");

var $aGmIr = parcelRequire("aGmIr");

var $kalkp = parcelRequire("kalkp");
var OBFUSCATED_FORMSPREE_ENDPOINT = "aHR0cHM6Ly9mb3Jtc3ByZWUuaW8vZi9tYmp3cGRwdw==";
var DATA_URL = "https://devious-digitizer-data.netlify.app/";
var cloneTemplate = (0, $cixNf.cloneTemplateFrom)(document);
customElements.define('closing-details', (0, $jPFnF.ClosingDetails), {
    extends: 'details'
});
customElements.define('tab-panel', (0, $jPFnF.TabPanel));
customElements.define('tab-group', (0, $jPFnF.TabGroup));
customElements.define('tag-list', (0, $jPFnF.TagList), {
    extends: 'ul'
});
customElements.define('modal-overlay', (0, $jPFnF.ModalOverlay));
customElements.define('dialog-prompt', (0, $jPFnF.DialogPrompt));
customElements.define('toast-box', (0, $jPFnF.Toast));
//document.getElementById('landing_settings_link').addEventListener(
//    'click',
//    _ => document.body.append(settings(state.history[0].passage.title, routeTree))
//)
document.getElementById('landing_feedback_link').addEventListener('click', function(_) {
    return document.body.append(feedback(null, null, null, navigator.userAgent));
});
document.getElementById('landing_privacy_link').addEventListener('click', function(_) {
    return document.body.append(privacy());
});
document.getElementById('file_select').addEventListener('change', function(e) {
    return switchToStory(e.target.files[0]);
});
var dragDropOverlay = document.getElementById('drag_drop_overlay');
document.body.addEventListener('dragenter', function(e) {
    // TODO make nice drag drop overlay
    // new Overlay(null, ['Drag-and-drop icon goes here'])._overlay.open(document.body)
    e.preventDefault();
});
document.body.addEventListener('dragover', function(e) {
    return e.preventDefault();
});
document.body.addEventListener('dragleave', function(_) {
// document.querySelector('.drag_drop_overlay').close()
});
document.body.addEventListener('drop', function(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files) switchToStory(e.dataTransfer.files[0]);
});
/// TEMPLATES ///
// FIX fadeTime is unimplemented
function toast(text) {
    var lingerTime = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, fadeTime = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    var toast1 = document.createElement('toast-box');
    toast1.setAttribute('text', text);
    toast1.setAttribute('linger-time', lingerTime);
    //toast.setAttribute('fade-time', fadeTime)
    return toast1;
}
// modal prompt: "file does not appear to be a Devious World or Devious Mundanity file".
//      options: cancel (return false), try anyway (return true), clicking away is same as cancel
function askToConfirm(filename) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $2PJNN._)(function() {
        return (0, $39i23._)(this, function(_state) {
            return [
                2,
                new Promise(function(res, rej) {
                    var respond = function(response) {
                        return function(e) {
                            if (e.target == e.currentTarget) {
                                e.target.dispatchEvent((0, $jPFnF.ModalOverlay).closeRequest);
                                res(response);
                            }
                        };
                    };
                    var template = cloneTemplate('confirmation_template');
                    var prompt = template.querySelector('.confirm_prompt');
                    prompt.textContent = (0, $cixNf.substituteText)(prompt.textContent, {
                        filename: filename
                    });
                    template.querySelector('modal-overlay').addEventListener('click', respond(false));
                    template.querySelector('.cancel').addEventListener('click', respond(false));
                    template.querySelector('.try_anyway').addEventListener('click', respond(true));
                    document.body.append(template);
                })
            ];
        });
    })();
}
function sidebarMenu(tale, state, routeTree, userAgent) {
    var template = cloneTemplate('sidebar_menu_template');
    template.querySelector('.settings_link').addEventListener('click', function(_) {
        return document.body.append(settings(state.history[0].passage.title, routeTree));
    });
    template.querySelector('.feedback_link').addEventListener('click', function(_) {
        return document.body.append(feedback(tale, state, routeTree, userAgent));
    });
    template.querySelector('.privacy_link').addEventListener('click', function(_) {
        return document.body.append(privacy());
    });
    return template;
}
function settings(curr, routeTree) {
    var template = cloneTemplate('settings_template');
    var close = function(e) {
        if (e.target == e.currentTarget) e.target.dispatchEvent((0, $jPFnF.ModalOverlay).closeRequest);
    };
    template.querySelector('modal-overlay').addEventListener('click', close);
    template.querySelector('.close_settings').addEventListener('click', close);
    var tagEditor = template.querySelector('.tag_editor');
    tagEditor.value = gatherTags(curr, routeTree).join(' ');
    template.querySelector('.save_tags').addEventListener('click', function(_) {
        var psg = routeTree.get(curr);
        if (psg) psg.modifiedTags = tagEditor.value.split(' ');
        document.body.append(toast("tags saved!", 2));
    });
    // TODO? Add "revert tags" button
    template.querySelector('.export_metadata').addEventListener('click', function(_) {
        return (0, $cixNf.exportObject)(extractMetadata(routeTree), 'metadata.json');
    });
    return template;
}
// Caches form to make filled-in info persistent
var feedbackForm;
function buildFeedback() {
    var template = cloneTemplate('feedback_template');
    var close = function(e) {
        if (e.target == e.currentTarget) e.target.dispatchEvent((0, $jPFnF.ModalOverlay).closeRequest);
    };
    template.querySelector('modal-overlay').addEventListener('click', close);
    template.querySelector('.close_feedback').addEventListener('click', close);
    // give a visual indicator that debug_info is being disabled
    var debugInfo = template.querySelector('.debug_info');
    var includeDebugInfo = template.querySelector('.include_debug_info');
    includeDebugInfo.addEventListener('change', function(_) {
        debugInfo.disabled = !includeDebugInfo.checked;
    });
    var submit = function(type) {
        return function(e) {
            e.preventDefault();
            var feedbackID = `${type}-${(0, $FPA49.nanoid)(6)}`;
            // disable debug info when requested so it is not included in BUG feedback messages
            debugInfo.disabled = !includeDebugInfo.checked;
            var data = new FormData(e.target);
            data.append('id', feedbackID);
            var subject = `Devious Digitizer Feedback ${feedbackID}`;
            var body = (0, $1OMRv._)(data.entries()).map(function(param) {
                var _param = (0, $7xDhZ._)(param, 2), k = _param[0], v = _param[1];
                return `${k}: ${v}`;
            }).join('\n\n');
            document.body.append(feedbackPreview(subject, body, e.target));
        };
    };
    template.querySelector('.bug_report').addEventListener('submit', submit('BUG'));
    template.querySelector('.feature_request').addEventListener('submit', submit('REQ'));
    template.querySelector('.help_request').addEventListener('submit', submit('HLP'));
    template.querySelector('.submit_tags').addEventListener('submit', submit('TAG'));
    return template;
}
function feedback(tale, state, routeTree, userAgent) {
    feedbackForm !== null && feedbackForm !== void 0 ? feedbackForm : feedbackForm = buildFeedback().firstChild;
    feedbackForm.querySelector('.debug_info').textContent = gatherDebugInfo(tale, state, userAgent);
    if (routeTree !== null) feedbackForm.querySelector('.tag_changes').textContent = gatherTagChanges(routeTree);
    return feedbackForm;
}
function feedbackPreview(subject, body, form) {
    var template = cloneTemplate('feedback_preview_template');
    template.querySelector('.subject').textContent = subject;
    template.querySelector('.body').textContent = body;
    var close = function(e) {
        if (e.target == e.currentTarget) e.target.dispatchEvent((0, $jPFnF.ModalOverlay).closeRequest);
    };
    template.querySelector('modal-overlay').addEventListener('click', close);
    template.querySelector('.cancel').addEventListener('click', close);
    template.querySelector('.submit').addEventListener('click', function(e) {
        (0, $cixNf.encryptMessage)((0, (/*@__PURE__*/$parcel$interopDefault($aGmIr))), body).then(function(encryptedBody) {
            return sendFormspree(subject, encryptedBody);
        }).then(function(_) {
            form.reset();
            e.target.dispatchEvent((0, $jPFnF.ModalOverlay).closeRequest);
            document.body.append(toast("feedback sent successfully ^_^"));
        }).catch(function(msg) {
            return alert(`something went wrong:\n${msg}`);
        });
    });
    return template;
}
function privacy() {
    var template = cloneTemplate('privacy_template');
    var close = function(e) {
        if (e.target == e.currentTarget) e.target.dispatchEvent((0, $jPFnF.ModalOverlay).closeRequest);
    };
    template.querySelector('modal-overlay').addEventListener('click', close);
    template.querySelector('.close_privacy').addEventListener('click', close);
    return template;
}
function retrospective(curr, routeTree, tale) {
    var _routeTree_get_link, _routeTree_get;
    var template = cloneTemplate('retrospective_template');
    var _routeTree_get_link_text;
    template.querySelector('.choice--current').innerText = (_routeTree_get_link_text = (_routeTree_get = routeTree.get(curr)) === null || _routeTree_get === void 0 ? void 0 : (_routeTree_get_link = _routeTree_get.link) === null || _routeTree_get_link === void 0 ? void 0 : _routeTree_get_link.text) !== null && _routeTree_get_link_text !== void 0 ? _routeTree_get_link_text : '';
    template.querySelector('.past_passages').ontoggle = function(e) {
        if (e.target.open) {
            var _e_target;
            e.target.ontoggle = null;
            (_e_target = e.target).prepend.apply(_e_target, (0, $1OMRv._)(routeTree.getAncestryOf(curr).map(function(title) {
                var _routeTree_get_link, _routeTree_get;
                var _routeTree_get_link_text;
                return pastPassage((_routeTree_get_link_text = (_routeTree_get = routeTree.get(title)) === null || _routeTree_get === void 0 ? void 0 : (_routeTree_get_link = _routeTree_get.link) === null || _routeTree_get_link === void 0 ? void 0 : _routeTree_get_link.text) !== null && _routeTree_get_link_text !== void 0 ? _routeTree_get_link_text : 'Start', tale.get(title));
            })));
        }
    };
    return template;
}
function pastPassage(choice, psg) {
    var template = cloneTemplate('past_passage_template');
    template.querySelector('.choice--past').innerText = choice;
    template.querySelector('.past_passage__text').append(psg.render().querySelector('.body.content'));
    return template;
}
function passageTagViewer(tags) {
    var tagViewer = cloneTemplate('tag_viewer_template');
    tagViewer.querySelector('.tag_list').tags(tags);
    return tagViewer;
}
function inlineTagViewer(passageTags, routeTags) {
    var tagViewer = cloneTemplate('inline_tag_viewer_template');
    tagViewer.querySelector('.tag_list--passage').tags(passageTags);
    tagViewer.querySelector('.tag_list--route').tags(routeTags);
    return tagViewer;
}
/// Devious Digitizer ///
function gatherTags(title, routeTree) {
    var recursive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var _routeTree_get, _routeTree_get1;
    var _routeTree_get_modifiedTags, _ref;
    if (!recursive) return (_ref = (_routeTree_get_modifiedTags = (_routeTree_get = routeTree.get(title)) === null || _routeTree_get === void 0 ? void 0 : _routeTree_get.modifiedTags) !== null && _routeTree_get_modifiedTags !== void 0 ? _routeTree_get_modifiedTags : (_routeTree_get1 = routeTree.get(title)) === null || _routeTree_get1 === void 0 ? void 0 : _routeTree_get1.tags) !== null && _ref !== void 0 ? _ref : [];
    return (0, $cixNf.arrayUnique)((0, $cixNf.Tree).cata(routeTree, title, function(node) {
        var _instance;
        var _node_modifiedTags, _ref;
        return (_instance = (_ref = (_node_modifiedTags = node.modifiedTags) !== null && _node_modifiedTags !== void 0 ? _node_modifiedTags : node.tags) !== null && _ref !== void 0 ? _ref : []).concat.apply(_instance, (0, $1OMRv._)(node.children));
    }));
// arrayUnique([...(node.tags ?? []), ...node.children.flatMap(child => gatherTags(child, routeTree, true))])
}
function sendFormspree(subject, body) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $2PJNN._)(function() {
        var data, response, errMsg, data1;
        return (0, $39i23._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = new FormData();
                    data.append('subject', subject);
                    data.append('body', body);
                    return [
                        4,
                        fetch(atob(OBFUSCATED_FORMSPREE_ENDPOINT), {
                            method: 'POST',
                            body: data,
                            headers: {
                                'Accept': 'application/json'
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!!response.ok) return [
                        3,
                        3
                    ];
                    errMsg = "There was a problem while trying to send your feedback. Please try again in a moment.";
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    data1 = _state.sent();
                    if (Object.hasOwn(data1, 'errors')) throw new Error(errMsg + data1["errors"].map(function(error) {
                        return error["message"];
                    }).join(", "));
                    else throw new Error(errMsg);
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
function gatherDebugInfo(tale, state, userAgent) {
    return JSON.stringify({
        userAgent: userAgent,
        deviousVersion: tale === null || tale === void 0 ? void 0 : tale.title,
        currentPassage: state ? state.history[0].passage.title : null
    }, null, 2);
}
function gatherTagChanges(routeTree) {
    return JSON.stringify(Object.fromEntries((0, $1OMRv._)(routeTree).filter(function(param) {
        var _param = (0, $7xDhZ._)(param, 2), k = _param[0], v = _param[1];
        return v.hasOwnProperty('modifiedTags');
    }).map(function(param) {
        var _param = (0, $7xDhZ._)(param, 2), k = _param[0], v = _param[1];
        return [
            k,
            v.modifiedTags
        ];
    })), null, 2);
}
function switchToStory(file) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $2PJNN._)(function() {
        var storyText, storyDoc, confirmContinue;
        return (0, $39i23._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        file.text()
                    ];
                case 1:
                    storyText = _state.sent();
                    storyDoc = (0, $cixNf.parseDoc)(storyText);
                    if (!(!storyDoc.querySelector('#storeArea > [tiddler = "CharGenMain"]') && !storyDoc.querySelector('#storeArea > [tiddler = "Start"]'))) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        askToConfirm(file.name)
                    ];
                case 2:
                    confirmContinue = _state.sent();
                    if (!confirmContinue) return [
                        2
                    ];
                    _state.label = 3;
                case 3:
                    hideLanding();
                    loadDocIntoDom(storyDoc);
                    return [
                        4,
                        injectDigitizerFeatures()
                    ];
                case 4:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function hideLanding() {
    document.querySelector('.digitizer-landing').classList.add('digitizer-landing--inactive');
}
function loadDocIntoDom(doc) {
    document.head.insertAdjacentHTML("beforeend", doc.head.innerHTML);
    document.body.insertAdjacentHTML("beforeend", doc.body.innerHTML);
    // Defining tiddlerTitle globally circumvents strict mode breaking Twine's scripts
    globalThis.tiddlerTitle = '';
    document.head.querySelectorAll('script[title]').forEach(function(s) {
        return eval(s.text);
    });
    dispatchEvent(new Event('load'));
}
function injectDigitizerFeatures() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $2PJNN._)(function() {
        var store, passages, tale, state, DWChars, DMChars, metadataName, metadata, passageGraph, routeTree;
        return (0, $39i23._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    store = document.getElementById('storeArea');
                    passages = document.getElementById('passages');
                    tale = window.tale;
                    state = window.state;
                    // determine whether this is DW or DM by checking which character starts are present
                    DWChars = [
                        'allstarstart',
                        'youngpunkstart',
                        'quietonestart',
                        'runawaystart',
                        'GwynStart',
                        'BuddyStart',
                        'AustinStart',
                        'DavidStart',
                        'JackStart',
                        'MikeStart',
                        'ThaddeusStart',
                        'SweetKidStart',
                        'MeanGirlStart',
                        'GirlGamerStart',
                        'SelfSufficientStart',
                        'CallistaStart',
                        'BritStart',
                        'WilmaStart',
                        'HollyStart',
                        'CelesteStart',
                        'HelenStart',
                        'MareiStart',
                        'IreneStart'
                    ];
                    DMChars = [
                        'CaliburnStart',
                        'DefianceStart',
                        'EdithStart',
                        'FionaStart',
                        'IrethStart',
                        'KaiStart',
                        'KiaraStart',
                        'KonkoStart',
                        'LeoStart',
                        'MaxiaStart',
                        'NicholasStart',
                        'SimoneStart',
                        'SiphaStart',
                        'ValerieStart',
                        'YamiStart'
                    ];
                    metadataName = DWChars.some(tale.has, tale) ? 'DW_metadata.json' : DMChars.some(tale.has, tale) ? 'DM_metadata.json' : (0, $cixNf.err)('Story is neither Worldly nor Mundane');
                    return [
                        4,
                        fetch(DATA_URL + metadataName).then(function(res) {
                            return res.json();
                        })
                    ];
                case 1:
                    metadata = _state.sent();
                    // build a graph from passages' links
                    passageGraph = buildPassageGraph(store);
                    // render the graph into a tree of story routes by following links starting at CharGenMain and dropping cycles
                    routeTree = (0, $cixNf.Tree).fromGraphBfs(function(addChild, currentChild) {
                        return passageGraph.forEachLinkedNode(currentChild, // add to tree and frontier unless, child is 'Version History', which breaks the tree. This is a big hack.
                        function(child, link) {
                            return child.id !== 'Version History' ? addChild(child.id, Object.assign({
                                link: link.data
                            }, child.data)) : undefined;
                        }, true // only traverse outbound links
                        );
                    }, 'Start');
                    // decorate routeTree with tags and other metadata
                    routeTree.forEach(function(value, key) {
                        return routeTree.set(key, Object.assign(value, metadata[key]));
                    });
                    // dispatch events when switching passages
                    window.state.display = function(title, source, type, callback) {
                        passages.dispatchEvent(new CustomEvent('before_tale_display', {
                            detail: {
                                title: title,
                                source: source,
                                type: type,
                                callback: callback
                            }
                        }));
                        Object.getPrototypeOf(window.state).display.apply(this, [
                            title,
                            source,
                            type,
                            callback
                        ]);
                        passages.dispatchEvent(new CustomEvent('after_tale_display', {
                            detail: {
                                title: title,
                                source: source,
                                type: type,
                                callback: callback
                            }
                        }));
                    };
                    // (Twine conveniently cleans out the previous passage's viewers while removing the previous passage)
                    passages.addEventListener('after_tale_display', function(e) {
                        var curr = e.detail.title;
                        // if we have metadata for current passage
                        if (routeTree.has(curr)) {
                            // above passage, add a viewer for current passage's tags and
                            passages.prepend(passageTagViewer(gatherTags(curr, routeTree)));
                            // if the current passage has preceding passages
                            if (routeTree.get(curr).parent) // a retrospective of preceding passages
                            passages.prepend(retrospective(curr, routeTree, tale));
                        }
                    });
                    // add target passage name to passage links to assist in adding the inline tag viewers
                    passages.addEventListener('after_tale_display', function(e) {
                        return annotateLinksWithTheirTarget(e.detail.title, tale, passages.querySelector('.passage.transition-in > .body'));
                    });
                    // add inline tag viewer elements to new passages
                    passages.addEventListener('after_tale_display', function(e) {
                        return addLinkTagLists(passages.querySelector('.passage.transition-in > .body'), routeTree);
                    });
                    // Add sidebar links //
                    document.getElementById('sidebar').append(sidebarMenu(tale, state, routeTree, navigator.userAgent));
                    return [
                        2
                    ];
            }
        });
    })();
}
var getLinks = function(body) {
    return Array.from(body.matchAll(/\[\[(?:([^|]+)\|)?([^\]]+)\]\]/g)).map(function(param) {
        var _param = (0, $7xDhZ._)(param, 3), _ = _param[0], text = _param[1], target = _param[2];
        return {
            text: text,
            target: target
        };
    });
};
function buildPassageGraph(storeArea) {
    var g = $kalkp();
    var titles = new Set(Array.from(storeArea.children).map(function(el) {
        return el.getAttribute('tiddler');
    }));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = storeArea.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var passage = _step.value;
            var title = passage.getAttribute('tiddler');
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = getLinks(passage.innerText)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _step_value = _step1.value, text = _step_value.text, target = _step_value.target;
                    // only include links to passages that exist
                    if (titles.has(target)) // create a link between the current and target passages, creating a node for the
                    //   target passage if one does not yet exist, and annotating the link with its text
                    g.addLink(title, target, {
                        text: text
                    });
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return g;
}
function annotateLinksWithTheirTarget(title, tale, passageBody) {
    var linkTargets = getLinks(tale.get(title).text).map(function(param) {
        var target = param.target;
        return target;
    });
    var links = Array.from(passageBody.querySelectorAll('a'));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (0, $cixNf.take)(100, (0, $cixNf.zip)([
            links,
            linkTargets
        ]))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $7xDhZ._)(_step.value, 2), link = _step_value[0], target = _step_value[1];
            link.setAttribute('data-target', target);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function addLinkTagLists(passageBody, routeTree) {
    passageBody.querySelectorAll('a[data-target]').forEach(function(link) {
        var title = link.getAttribute('data-target') // NOTE depends on annotateLinksWithTheirTarget
        ;
        // if target passage exists
        if (routeTree.has(title)) link.before(inlineTagViewer(gatherTags(title, routeTree, false), gatherTags(title, routeTree, true)));
    });
}
function extractMetadata(routeTree) {
    var include = new Set([
        'tags',
        'modifiedTags'
    ]);
    var strip = function(value) {
        return (0, $cixNf.filterObjectByKey)(value, function(key) {
            return include.has(key);
        });
    };
    return routeTree.toObject(function(param) {
        var _param = (0, $7xDhZ._)(param, 2), key = _param[0], value = _param[1];
        return [
            key,
            strip(value)
        ];
    });
}

});
parcelRegister("2PJNN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2103df87ef9d8b41$export$71511d61b312f219; });
function $2103df87ef9d8b41$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $2103df87ef9d8b41$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $2103df87ef9d8b41$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $2103df87ef9d8b41$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("7xDhZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $57da17798b6ad5a5$export$71511d61b312f219; });

var $hcXtQ = parcelRequire("hcXtQ");

var $cQXMN = parcelRequire("cQXMN");

var $9QXnP = parcelRequire("9QXnP");

var $8s3Py = parcelRequire("8s3Py");
function $57da17798b6ad5a5$export$71511d61b312f219(arr, i) {
    return (0, $hcXtQ._)(arr) || (0, $cQXMN._)(arr, i) || (0, $8s3Py._)(arr, i) || (0, $9QXnP._)();
}

});
parcelRegister("hcXtQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c871b237b0fb0343$export$71511d61b312f219; });
function $c871b237b0fb0343$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("cQXMN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $026a348297c910fd$export$71511d61b312f219; });
function $026a348297c910fd$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("9QXnP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $72c708afcf0d702c$export$71511d61b312f219; });
function $72c708afcf0d702c$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("8s3Py", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6273e8e78d5743b8$export$71511d61b312f219; });

var $duYsf = parcelRequire("duYsf");
function $6273e8e78d5743b8$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $duYsf._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $duYsf._)(o, minLen);
}

});
parcelRegister("duYsf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9d3cf8bbb909d7d1$export$71511d61b312f219; });
function $9d3cf8bbb909d7d1$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("1OMRv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $15305cf345d3e6bc$export$71511d61b312f219; });

var $1VJZ2 = parcelRequire("1VJZ2");

var $f0CSJ = parcelRequire("f0CSJ");

var $fxgHG = parcelRequire("fxgHG");

var $8s3Py = parcelRequire("8s3Py");
function $15305cf345d3e6bc$export$71511d61b312f219(arr) {
    return (0, $1VJZ2._)(arr) || (0, $f0CSJ._)(arr) || (0, $8s3Py._)(arr) || (0, $fxgHG._)();
}

});
parcelRegister("1VJZ2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $167ec8b0d6737051$export$71511d61b312f219; });

var $duYsf = parcelRequire("duYsf");
function $167ec8b0d6737051$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $duYsf._)(arr);
}

});

parcelRegister("f0CSJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $aed5043b586f273f$export$71511d61b312f219; });
function $aed5043b586f273f$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("fxgHG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b4f6e511112d7c14$export$71511d61b312f219; });
function $b4f6e511112d7c14$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("39i23", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $24b0332f0379ac29$export$71511d61b312f219; });
function $24b0332f0379ac29$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});

parcelRegister("FPA49", function(module, exports) {

$parcel$export(module.exports, "nanoid", function () { return $07dbd74de6c04caf$export$ac4959f4f1338dfc; });

var $k4UwZ = parcelRequire("k4UwZ");
var $07dbd74de6c04caf$export$4385e60b38654f68 = function(bytes) {
    return crypto.getRandomValues(new Uint8Array(bytes));
};
var $07dbd74de6c04caf$export$a5cee9e955a615e5 = function(alphabet, defaultSize, getRandom) {
    var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    var step = -~(1.6 * mask * defaultSize / alphabet.length);
    return function() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultSize;
        if (size <= 0) return '';
        var id = '';
        while(true){
            var bytes = getRandom(step);
            var j = step | 0;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length === size) return id;
            }
        }
    };
};
var $07dbd74de6c04caf$export$62e99e5c9f473d7f = function(alphabet) {
    var size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 21;
    return $07dbd74de6c04caf$export$a5cee9e955a615e5(alphabet, size, $07dbd74de6c04caf$export$4385e60b38654f68);
};
var $07dbd74de6c04caf$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    return crypto.getRandomValues(new Uint8Array(size)).reduce(function(id, byte) {
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += '-';
        else id += '_';
        return id;
    }, '');
};

});
parcelRegister("k4UwZ", function(module, exports) {
var $e9e00842ef40126b$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

});


parcelRegister("jPFnF", function(module, exports) {

$parcel$export(module.exports, "ClosingDetails", function () { return $e702e114f593b1e4$export$ee7265346f578d9d; });
$parcel$export(module.exports, "TabPanel", function () { return $e702e114f593b1e4$export$3d96ec278d3efce4; });
$parcel$export(module.exports, "TabGroup", function () { return $e702e114f593b1e4$export$85fd4ed3b8ca1010; });
$parcel$export(module.exports, "TagList", function () { return $e702e114f593b1e4$export$f9fef0f55402315b; });
$parcel$export(module.exports, "ModalOverlay", function () { return $e702e114f593b1e4$export$8948f78d83984c69; });
$parcel$export(module.exports, "DialogPrompt", function () { return $e702e114f593b1e4$export$bf1308127b24ea84; });
$parcel$export(module.exports, "Toast", function () { return $e702e114f593b1e4$export$8d8dc7d5f743331b; });
// import * as petit from 'petit-dom'
// const el = petit.h
// const render = (parent, child, opts) => petit.render(child, parent, opts)
// import { el, mount } from 'redom'

var $3KgX2 = parcelRequire("3KgX2");

var $hwIvm = parcelRequire("hwIvm");

var $5knxi = parcelRequire("5knxi");

var $cYNnT = parcelRequire("cYNnT");

var $1cD6J = parcelRequire("1cD6J");

var $1OMRv = parcelRequire("1OMRv");

var $atnJC = parcelRequire("atnJC");
parcelRequire("fOmVu");
var $iiqW2 = parcelRequire("iiqW2");

var $FPA49 = parcelRequire("FPA49");

var $cixNf = parcelRequire("cixNf");

var $ln5rx = parcelRequire("ln5rx");

var $8b7cE = parcelRequire("8b7cE");
var $e702e114f593b1e4$var$stream = (0, (/*@__PURE__*/$parcel$interopDefault($ln5rx))).stream;
var $e702e114f593b1e4$var$combine = function(streams, fn) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ln5rx))).combine(fn, streams);
};
var $e702e114f593b1e4$var$update = function(s, fn) {
    return s(fn(s()));
};
//const sideEffect = flyd.curryN(2, (fn, s) => flyd.map(x => {fn(x); return x;}, s))
var $e702e114f593b1e4$var$updateAttribute = function(srm, attr, obj) {
    return (0, $cixNf.pipe)(srm, (0, $8b7cE.dropRepeats), (0, (/*@__PURE__*/$parcel$interopDefault($ln5rx))).on(function(x) {
        return obj.getAttribute(attr) === x ? null : obj.setAttribute(attr, x);
    }));
};
var $e702e114f593b1e4$export$ee7265346f578d9d = /*#__PURE__*/ function(HTMLDetailsElement1) {
    "use strict";
    (0, $1cD6J._)(ClosingDetails, HTMLDetailsElement1);
    function ClosingDetails() {
        (0, $hwIvm._)(this, ClosingDetails);
        var _this;
        _this = (0, $3KgX2._)(this, ClosingDetails);
        _this._closeIfUnfocused = function(e) {
            if (!_this.contains(document.elementFromPoint(e.clientX, e.clientY))) _this.open = false;
        };
        return _this;
    }
    (0, $5knxi._)(ClosingDetails, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                document.body.addEventListener('mousedown', this._closeIfUnfocused);
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                document.body.removeEventListener('mousedown', this._closeIfUnfocused);
            }
        }
    ]);
    return ClosingDetails;
}((0, $atnJC._)(HTMLDetailsElement));
var $e702e114f593b1e4$export$3d96ec278d3efce4 = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $1cD6J._)(TabPanel, HTMLElement1);
    function TabPanel() {
        (0, $hwIvm._)(this, TabPanel);
        var _this;
        _this = (0, $3KgX2._)(this, TabPanel), (0, $cYNnT._)(_this, "idChanged", $e702e114f593b1e4$var$stream(null)), (0, $cYNnT._)(_this, "title", $e702e114f593b1e4$var$stream()), (0, $cYNnT._)(_this, "_onTitleChanged", $e702e114f593b1e4$var$updateAttribute(_this.title, 'title', _this)), (0, $cYNnT._)(_this, "group", $e702e114f593b1e4$var$stream()), (0, $cYNnT._)(_this, "active", $e702e114f593b1e4$var$combine([
            _this.group.chain(function(g) {
                return g === null || g === void 0 ? void 0 : g.active;
            }),
            _this.idChanged
        ], function(gActive, _) {
            var active = gActive() === _this.id;
            (0, $cixNf.setClass)(_this, 'active', active);
            return active;
        }));
        _this.attachShadow({
            mode: 'open'
        });
        _this.shadowRoot.append((0, $iiqW2.default)('style', null, ':host {display: none;} :host(.active) {display: block;}'), (0, $iiqW2.default)('div', {
            role: 'tabpanel'
        }, (0, $iiqW2.default)('slot')));
        return _this;
    }
    (0, $5knxi._)(TabPanel, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var _this_getAttribute;
                this.title((_this_getAttribute = this.getAttribute('title')) !== null && _this_getAttribute !== void 0 ? _this_getAttribute : '');
                this.group(this.parentElement instanceof $e702e114f593b1e4$export$85fd4ed3b8ca1010 ? this.parentElement : null);
                this.id = this.id || (0, $FPA49.nanoid)(10);
            }
        },
        {
            key: "attributeChangedCallback",
            value: function attributeChangedCallback(name, oldVal, newVal) {
                if (name === 'id') this.idChanged(null);
                else if (name === 'title') this.title(newVal);
            }
        }
    ], [
        {
            key: "observedAttributes",
            get: function get() {
                return [
                    'id',
                    'title'
                ];
            }
        }
    ]);
    return TabPanel;
}((0, $atnJC._)(HTMLElement));
var $e702e114f593b1e4$export$85fd4ed3b8ca1010 = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $1cD6J._)(TabGroup, HTMLElement1);
    function TabGroup() {
        (0, $hwIvm._)(this, TabGroup);
        var _this;
        _this = (0, $3KgX2._)(this, TabGroup), (0, $cYNnT._)(_this, "defaultTabTitle", ''), (0, $cYNnT._)(_this, "tabs", $e702e114f593b1e4$var$stream()), (0, $cYNnT._)(_this, "active", $e702e114f593b1e4$var$stream(null)), (0, $cYNnT._)(_this, "_onActiveChanged", $e702e114f593b1e4$var$updateAttribute(_this.active, 'active', _this)), (0, $cYNnT._)(_this, "renderTabList", $e702e114f593b1e4$var$combine([
            _this.tabs,
            _this.active
        ], function(tabs, active) {
            var _this_shadowRoot_getElementById;
            // if `active` isn't a valid reference to a child tab-panel, default to the first tab-panel
            if (!tabs().some(function(el) {
                return el.id === active();
            })) {
                var _tabs_;
                _this.active((_tabs_ = tabs()[0]) === null || _tabs_ === void 0 ? void 0 : _tabs_.id);
                return;
            }
            (_this_shadowRoot_getElementById = _this.shadowRoot.getElementById('tablist')).replaceChildren.apply(_this_shadowRoot_getElementById, (0, $1OMRv._)(tabs().map(function(tab) {
                return (0, $iiqW2.default)('li', {
                    class: 'tab' + (active() === tab.id ? ' active' : ''),
                    onclick: function() {
                        return _this.active(tab.id);
                    },
                    'aria-controls': tab.id,
                    role: 'tab'
                }, tab.title() || _this.defaultTabTitle);
            })));
        }));
        _this.attachShadow({
            mode: 'open'
        });
        _this.shadowRoot.append((0, $iiqW2.default)('style', null, `
                #tabgroup { display: flex; flex-flow: var(--tabs-position, column) nowrap; gap: var(--tablist-gap, 0); }
                #tablist { display: flex; flex-flow: var(--tabs-flow, row wrap); align-items: var(--tab-align); margin: 0;
                    padding: 0; gap: var(--tabs-gap, .5em); }
                .tab { display: block; background: var(--tab-background); cursor: var(--tab-cursor); padding: var(--tab-padding);
                    border: var(--tab-border); border-style: var(--tab-border-style); border-color: var(--tab-border-color);
                    border-width: var(--tab-border-width); border-radius: var(--tab-border-radius); }
                .tab.active { background: var(--tab-active-background); border: var(--tab-active-border);
                    border-style: var(--tab-active-border-style); border-color: var(--tab-active-border-color);
                    border-width: var(--tab-active-border-width); border-radius: var(--tab-active-border-radius); }`), (0, $iiqW2.default)('div', {
            part: 'tabgroup',
            role: 'wrapper',
            id: 'tabgroup'
        }, [
            (0, $iiqW2.default)('slot'),
            (0, $iiqW2.default)('menu', {
                part: 'tablist',
                role: 'tablist',
                id: 'tablist'
            })
        ]));
        _this.shadowRoot.querySelector('slot').addEventListener('slotchange', function(e) {
            return _this.tabs(e.target.assignedElements().filter(function(x) {
                return x instanceof $e702e114f593b1e4$export$3d96ec278d3efce4;
            }));
        });
        return _this;
    }
    (0, $5knxi._)(TabGroup, [
        {
            key: "attributeChangedCallback",
            value: function attributeChangedCallback(name, oldVal, newVal) {
                if (name === 'active') this.active(newVal);
            }
        }
    ], [
        {
            key: "observedAttributes",
            get: function get() {
                return [
                    'active'
                ];
            }
        }
    ]);
    return TabGroup;
}((0, $atnJC._)(HTMLElement));
var $e702e114f593b1e4$export$f9fef0f55402315b = /*#__PURE__*/ function(HTMLUListElement1) {
    "use strict";
    (0, $1cD6J._)(TagList, HTMLUListElement1);
    function TagList() {
        (0, $hwIvm._)(this, TagList);
        var _this;
        _this = (0, $3KgX2._)(this, TagList, arguments), (0, $cYNnT._)(_this, "connected", $e702e114f593b1e4$var$stream()), (0, $cYNnT._)(_this, "tags", $e702e114f593b1e4$var$stream([])), (0, $cYNnT._)(_this, "render", $e702e114f593b1e4$var$combine([
            _this.tags,
            _this.connected
        ], function(tags) {
            return(// TODO convert to using attodom.list?
            _this.replaceChildren.apply(_this, (0, $1OMRv._)(tags().sort().map(function(tag) {
                return (0, $iiqW2.default)('li', {
                    class: 'tag_list__tag'
                }, tag);
            }))));
        }));
        return _this;
    }
    (0, $5knxi._)(TagList, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                this.connected(true);
            }
        }
    ]);
    return TagList;
}((0, $atnJC._)(HTMLUListElement));
var $e702e114f593b1e4$export$8948f78d83984c69 = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $1cD6J._)(ModalOverlay, HTMLElement1);
    function ModalOverlay() {
        (0, $hwIvm._)(this, ModalOverlay);
        var _this;
        _this = (0, $3KgX2._)(this, ModalOverlay);
        _this.attachShadow({
            mode: 'open'
        });
        _this.shadowRoot.append((0, $iiqW2.default)('style', null, `
                #overlay {
                    display: var(--overlay-display, flex); flex-flow: column nowrap; justify-content: safe center;
                    align-items: center;

                    position: fixed; z-index: 1; left: 0; top: 0; width: 100%; height: 100%;
                    overflow: auto;

                    background-color: var(--overlay-color, rgba(0,0,0,0.4));
                }`), (0, $iiqW2.default)('div', {
            id: 'overlay'
        }, [
            (0, $iiqW2.default)('slot')
        ]));
        _this.addEventListener('request_overlay_close', function(e) {
            e.stopPropagation();
            _this.close();
        });
        return _this;
    }
    (0, $5knxi._)(ModalOverlay, [
        {
            key: "open",
            value: function open(parent) {
                parent.appendChild(this._overlay);
            }
        },
        {
            key: "close",
            value: function close() {
                this.remove();
            }
        }
    ]);
    return ModalOverlay;
}((0, $atnJC._)(HTMLElement));
(0, $cYNnT._)($e702e114f593b1e4$export$8948f78d83984c69, "closeRequest", new Event('request_overlay_close', {
    bubbles: true,
    cancelable: true
}));
var $e702e114f593b1e4$export$bf1308127b24ea84 = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $1cD6J._)(DialogPrompt, HTMLElement1);
    function DialogPrompt() {
        (0, $hwIvm._)(this, DialogPrompt);
        var _this;
        _this = (0, $3KgX2._)(this, DialogPrompt);
        _this.attachShadow({
            mode: 'open'
        });
        _this.shadowRoot.append((0, $iiqW2.default)('style', null, `
                #dialog {
                    background-color: var(--dialog-color, grey); padding: var(--dialog-padding, 2em);
                    border: var(--dialog-border); border-radius: var(--dialog-border-radius);
                }

                #buttons {
                    display: flex; flex-flow: row wrap; justify-content: space-around;
                    align-items: center; align-content: space-around; border: none;
                }`), (0, $iiqW2.default)('form', {
            id: 'dialog',
            onsubmit: function(_) {
                return false;
            }
        }, [
            (0, $iiqW2.default)('slot', {
                name: 'prompt'
            }),
            (0, $iiqW2.default)('fieldset', {
                id: 'buttons'
            }, [
                (0, $iiqW2.default)('slot', {
                    name: 'buttons'
                })
            ])
        ]));
        return _this;
    }
    return DialogPrompt;
}((0, $atnJC._)(HTMLElement));
var $e702e114f593b1e4$export$8d8dc7d5f743331b = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $1cD6J._)(Toast, HTMLElement1);
    function Toast() {
        (0, $hwIvm._)(this, Toast);
        var _this;
        _this = (0, $3KgX2._)(this, Toast);
        _this.attachShadow({
            mode: 'open'
        });
        _this.shadowRoot.append((0, $iiqW2.default)('style', null, `
                @keyframes fadeOut {
                    from {opacity: 1;}
                    to {opacity: 0;}
                }
                
                #toast {
                    background-color: var(--toast-color, grey); padding: var(--toast-padding, 2em);
                    border: var(--toast-border); border-radius: var(--toast-border-radius);
                    position: fixed; z-index: 1; left: 50%; bottom: 25%; transform: -50%;
                }
                
                #toast.fade {
                    animation: fadeOut 1s ease-in;
                }` // TODO make fade out time customizable
        ), (0, $iiqW2.default)('p', {
            id: 'toast'
        }));
        _this.shadowRoot.getElementById('toast').addEventListener('animationend', function(e) {
            if (e.animationName === 'fadeOut') _this.remove();
        });
        return _this;
    }
    (0, $5knxi._)(Toast, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var toast = this.shadowRoot.getElementById('toast');
                toast.textContent = this.getAttribute('text');
                (0, $cixNf.sleep)(Number(this.getAttribute('linger-time')) * 1000).then(function(_) {
                    return toast.classList.add('fade');
                });
            }
        }
    ]);
    return Toast;
}((0, $atnJC._)(HTMLElement));

});
parcelRegister("3KgX2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2ba2d11f7bac53ac$export$71511d61b312f219; });

var $9rTWz = parcelRequire("9rTWz");

var $iZnj0 = parcelRequire("iZnj0");

var $3DOfK = parcelRequire("3DOfK");
function $2ba2d11f7bac53ac$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $9rTWz._)(derived);
    return (0, $3DOfK._)(_this, (0, $iZnj0._)() ? Reflect.construct(derived, args || [], (0, $9rTWz._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("9rTWz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6e1207edfc5a6547$export$71511d61b312f219; });
function $6e1207edfc5a6547$export$71511d61b312f219(o) {
    $6e1207edfc5a6547$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6e1207edfc5a6547$export$71511d61b312f219(o);
}

});

parcelRegister("iZnj0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $dd300084c0bf6991$export$71511d61b312f219; });
function $dd300084c0bf6991$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($dd300084c0bf6991$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("3DOfK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2a6bfecd97be9ce6$export$71511d61b312f219; });

var $c1FRS = parcelRequire("c1FRS");

var $4yFOg = parcelRequire("4yFOg");
function $2a6bfecd97be9ce6$export$71511d61b312f219(self, call) {
    if (call && ((0, $4yFOg._)(call) === "object" || typeof call === "function")) return call;
    return (0, $c1FRS._)(self);
}

});
parcelRegister("c1FRS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8c160e23c413f899$export$71511d61b312f219; });
function $8c160e23c413f899$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("4yFOg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $351ac4e9dae74233$export$71511d61b312f219; });
function $351ac4e9dae74233$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



parcelRegister("hwIvm", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cc27f288a16504cb$export$71511d61b312f219; });
function $cc27f288a16504cb$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("5knxi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3e1113c53aa1b567$export$71511d61b312f219; });
function $3e1113c53aa1b567$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3e1113c53aa1b567$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $3e1113c53aa1b567$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3e1113c53aa1b567$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("cYNnT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $97316558896f791c$export$71511d61b312f219; });
function $97316558896f791c$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("1cD6J", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0e053f60258a2a0a$export$71511d61b312f219; });

var $algHK = parcelRequire("algHK");
function $0e053f60258a2a0a$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $algHK._)(subClass, superClass);
}

});
parcelRegister("algHK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7878d2bd9caa86c8$export$71511d61b312f219; });
function $7878d2bd9caa86c8$export$71511d61b312f219(o, p) {
    $7878d2bd9caa86c8$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7878d2bd9caa86c8$export$71511d61b312f219(o, p);
}

});


parcelRegister("atnJC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $79ff0608c8414f09$export$71511d61b312f219; });

var $5xdvd = parcelRequire("5xdvd");

var $9rTWz = parcelRequire("9rTWz");

var $naUUQ = parcelRequire("naUUQ");

var $algHK = parcelRequire("algHK");
function $79ff0608c8414f09$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $79ff0608c8414f09$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $naUUQ._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $5xdvd._)(Class, arguments, (0, $9rTWz._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $algHK._)(Wrapper, Class);
    };
    return $79ff0608c8414f09$export$71511d61b312f219(Class);
}

});
parcelRegister("5xdvd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $407a82227cb9d9f6$export$71511d61b312f219; });

var $iZnj0 = parcelRequire("iZnj0");

var $algHK = parcelRequire("algHK");
function $407a82227cb9d9f6$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $iZnj0._)()) $407a82227cb9d9f6$export$71511d61b312f219 = Reflect.construct;
    else $407a82227cb9d9f6$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $algHK._)(instance, Class.prototype);
        return instance;
    };
    return $407a82227cb9d9f6$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("naUUQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $045a9dfc39616145$export$71511d61b312f219; });
function $045a9dfc39616145$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("fOmVu", function(module, exports) {

$parcel$export(module.exports, "el", function () { return (parcelRequire("iiqW2")).default; });
// @ts-check
/* eslint-disable global-require */ 
var $iiqW2 = parcelRequire("iiqW2");

var $7iNlt = parcelRequire("7iNlt");

var $kvXGg = parcelRequire("kvXGg");

var $cgPcZ = parcelRequire("cgPcZ");

var $veFAr = parcelRequire("veFAr");

});
parcelRegister("iiqW2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d51ecd2b1d9c0d1f$export$2e2bcd8739ae039; });

var $lMVrw = parcelRequire("lMVrw");
var $d51ecd2b1d9c0d1f$var$htmlProps = {
    id: true,
    nodeValue: true,
    textContent: true,
    className: true,
    innerHTML: true,
    tabIndex: true,
    value: true
};
function $d51ecd2b1d9c0d1f$export$2e2bcd8739ae039(tagName) {
    //@ts-ignore
    var node = tagName.nodeType === 1 ? tagName : document.createElement(tagName);
    for(var i = 1; i < arguments.length; ++i){
        var arg = arguments[i];
        if (arg != null) {
            //TODO skip .constructor
            if (!arg.constructor || arg.constructor === Object) for(var j = 0, ks = Object.keys(arg); j < ks.length; ++j){
                var key = ks[j], val = arg[key];
                if (key === 'style') node.style.cssText = val;
                else if (typeof val !== 'string' || $d51ecd2b1d9c0d1f$var$htmlProps[key]) {
                    node[key] = val;
                    //set synthetic events for onUpperCaseName
                    if (key[0] === 'o' && key[1] === 'n' && key.charCodeAt(2) < 91 && key.charCodeAt(2) > 64 && !(0, $lMVrw.default)[key]) {
                        document.addEventListener(key.slice(2).toLowerCase(), function(e) {
                            var tgt = e.target;
                            do if (tgt[key]) return tgt[key](e);
                            while (tgt = tgt.parentNode);
                        });
                        (0, $lMVrw.default)[key] = true;
                    }
                } else node.setAttribute(key, val);
            }
            else {
                if (Array.isArray(arg)) for(var k = 0; k < arg.length; ++k)node.appendChild(arg[k].nodeType ? arg[k] : document.createTextNode(arg[k]));
                else node.appendChild(arg.nodeType ? arg : document.createTextNode(arg));
            }
        }
    }
    return node;
}

});
parcelRegister("lMVrw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdcaa3a528802fc4$export$2e2bcd8739ae039; });
var $fdcaa3a528802fc4$export$2e2bcd8739ae039 = {};

});


parcelRegister("7iNlt", function(module, exports) {

var $lMVrw = parcelRequire("lMVrw");
function $55107dcb5b85b85d$export$2e2bcd8739ae039(tagName) {
    //@ts-ignore
    var node = tagName.nodeType === 1 ? tagName : document.createElementNS('http://www.w3.org/2000/svg', tagName);
    for(var i = 1; i < arguments.length; ++i){
        var arg = arguments[i];
        if (arg != null) {
            //TODO skip .constructor
            if (!arg.constructor || arg.constructor === Object) for(var j = 0, ks = Object.keys(arg); j < ks.length; ++j){
                var key = ks[j], val = arg[key];
                if (typeof val !== 'string') {
                    node[key] = val;
                    //set synthetic events for onUpperCaseName
                    if (key[0] === 'o' && key[1] === 'n' && key.charCodeAt(2) < 91 && key.charCodeAt(2) > 64 && !(0, $lMVrw.default)[key]) {
                        document.addEventListener(key.slice(2).toLowerCase(), function(e) {
                            var tgt = e.target;
                            do if (tgt[key]) return tgt[key](e);
                            while (tgt = tgt.parentNode);
                        });
                        (0, $lMVrw.default)[key] = true;
                    }
                } else node.setAttribute(key, val);
            }
            else {
                if (Array.isArray(arg)) for(var k = 0; k < arg.length; ++k)node.appendChild(arg[k].nodeType ? arg[k] : document.createTextNode(arg[k]));
                else node.appendChild(arg.nodeType ? arg : document.createTextNode(arg));
            }
        }
    }
    return node;
}

});

parcelRegister("kvXGg", function(module, exports) {
/**
 * @param {Element} parent
 * @param {Function} factory
 * @param {Object} [options]
 * @return {Object}
 */ function $eef4ff414e10a2fb$export$2e2bcd8739ae039(parent, factory, options) {
    return {
        parent: parent,
        factory: factory,
        before: options && options.before || null,
        after: options && options.after || null,
        update: $eef4ff414e10a2fb$var$updateList,
        key: options && options.key || function(v, i) {
            return i;
        },
        map: Object.create(null)
    };
}
/**
 * @param {Array} arr
 * @return {Node}
 */ function $eef4ff414e10a2fb$var$updateList(arr) {
    var parent = this.parent, spot = this.after ? this.after.nextSibling : parent.firstChild, getK = this.key, kids = Object.create(null);
    if (!arr.length && !this.before && !this.after) parent.textContent = '';
    else {
        for(var i = 0; i < arr.length; ++i){
            //TODO skip .constructor
            var key = getK.constructor === Function ? getK(arr[i], i, arr) : arr[i][getK], kid = this.map[key];
            //create or update kid
            if (kid) kid.update && kid.update(arr[i], key, arr) //eslint-disable-line
            ;
            else kid = this.factory(arr[i], i, arr);
            kids[key] = kid;
            //place kid
            if (!spot) parent.appendChild(kid);
            else if (kid === spot.nextSibling) parent.removeChild(spot);
            else if (kid !== spot) parent.insertBefore(kid, spot);
            spot = kid.nextSibling;
        }
        //delete remaining
        while(spot !== this.before){
            var next = spot.nextSibling;
            parent.removeChild(spot);
            spot = next;
        }
    }
    this.map = kids;
    return this;
}

});

parcelRegister("cgPcZ", function(module, exports) {
function $8eeeb395dcb5edad$export$2e2bcd8739ae039(start, test, until) {
    var spot = start, last = until || null;
    while(!test(spot)){
        if (spot === last) return null // specified end reached
        ;
        var next = spot.firstChild;
        // if no child get sibling, if no sibling, retry with parent
        if (!next) while(!(next = spot.nextSibling)){
            spot = spot.parentNode;
            if (spot === null) return null // end of tree reached
            ;
        }
        spot = next;
    }
    return spot;
}

});

parcelRegister("veFAr", function(module, exports) {
/**
 * @param {string} cssRuleText
 * @return {void}
 */ function $05de4678f43f2a83$export$2e2bcd8739ae039(cssRuleText) {
    /**@type {CSSStyleSheet} */ //@ts-ignore
    var sheet = document.styleSheets[0] || document.head.appendChild(document.createElement('style')).sheet;
    sheet.insertRule(cssRuleText, sheet.cssRules.length);
}

});


parcelRegister("cixNf", function(module, exports) {

$parcel$export(module.exports, "setClass", function () { return $8f41611a449c55bb$export$2796c4ce44e61efa; });
$parcel$export(module.exports, "err", function () { return $8f41611a449c55bb$export$8048b892d651b310; });
$parcel$export(module.exports, "sleep", function () { return $8f41611a449c55bb$export$e772c8ff12451969; });
$parcel$export(module.exports, "pipe", function () { return $8f41611a449c55bb$export$a4627e546088548d; });
$parcel$export(module.exports, "zip", function () { return $8f41611a449c55bb$export$8901015135f2fb22; });
$parcel$export(module.exports, "take", function () { return $8f41611a449c55bb$export$b7df5d561049483a; });
$parcel$export(module.exports, "arrayUnique", function () { return $8f41611a449c55bb$export$7bf6fd20e75fd96; });
$parcel$export(module.exports, "filterObjectByKey", function () { return $8f41611a449c55bb$export$cf80d7b87eda7a5b; });
$parcel$export(module.exports, "substituteText", function () { return $8f41611a449c55bb$export$f7404bda8d1e381c; });
$parcel$export(module.exports, "Tree", function () { return $8f41611a449c55bb$export$7fbedc92909ed28e; });
$parcel$export(module.exports, "cloneTemplateFrom", function () { return $8f41611a449c55bb$export$42e04a57be803477; });
$parcel$export(module.exports, "parseDoc", function () { return $8f41611a449c55bb$export$5db361593220645; });
$parcel$export(module.exports, "exportObject", function () { return $8f41611a449c55bb$export$ac1f1552ea16f7d5; });
$parcel$export(module.exports, "encryptMessage", function () { return $8f41611a449c55bb$export$802132930513888b; });

var $2PJNN = parcelRequire("2PJNN");

var $3KgX2 = parcelRequire("3KgX2");

var $hwIvm = parcelRequire("hwIvm");

var $5xdvd = parcelRequire("5xdvd");

var $5knxi = parcelRequire("5knxi");

var $cYNnT = parcelRequire("cYNnT");

var $1cD6J = parcelRequire("1cD6J");

var $e5Zy6 = parcelRequire("e5Zy6");

var $gRtWz = parcelRequire("gRtWz");

var $7xDhZ = parcelRequire("7xDhZ");

var $1OMRv = parcelRequire("1OMRv");

var $atnJC = parcelRequire("atnJC");

var $39i23 = parcelRequire("39i23");

var $19YAp = parcelRequire("19YAp");
var $8f41611a449c55bb$export$411ce8e5a71e3069 = function(x, y) {
    return x === y;
};
var $8f41611a449c55bb$export$2796c4ce44e61efa = function(elem, cl, bool) {
    return bool ? elem.classList.add(cl) : elem.classList.remove(cl);
};
var $8f41611a449c55bb$export$8048b892d651b310 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    throw (0, $5xdvd._)(Error, (0, $1OMRv._)(args));
};
var $8f41611a449c55bb$export$e772c8ff12451969 = function(ms) {
    return new Promise(function(res) {
        return setTimeout(res, ms);
    });
};
var $8f41611a449c55bb$export$a4627e546088548d = function(x) {
    for(var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        fns[_key - 1] = arguments[_key];
    }
    return fns.reduce(function(acc, fn) {
        return fn(acc);
    }, x);
};
var $8f41611a449c55bb$export$ccc7b0636abaffc3 = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(acc, fn) {
            return fn(acc);
        }, x);
    };
};
var $8f41611a449c55bb$export$8901015135f2fb22 = function(rows) {
    return rows[0].map(function(_, c) {
        return rows.map(function(row) {
            return row[c];
        });
    });
};
function $8f41611a449c55bb$export$b7df5d561049483a(n, iter) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, x, err;
    return (0, $39i23._)(this, function(_state) {
        switch(_state.label){
            case 0:
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _iterator = iter[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    5
                ];
                x = _step.value;
                if (n < 1) return [
                    3,
                    5
                ];
                return [
                    4,
                    x
                ];
            case 3:
                _state.sent();
                n -= 1;
                _state.label = 4;
            case 4:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 5:
                return [
                    3,
                    8
                ];
            case 6:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    8
                ];
            case 7:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 8:
                return [
                    2
                ];
        }
    });
}
function $8f41611a449c55bb$export$667066422fa0af46() {
    for(var _len = arguments.length, sets = new Array(_len), _key = 0; _key < _len; _key++){
        sets[_key] = arguments[_key];
    }
    var union = new Set(sets.shift());
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = sets[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var currSet = _step.value;
            try {
                for(var _iterator1 = currSet[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var elem = _step1.value;
                    union.add(elem);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return union;
}
var $8f41611a449c55bb$export$7bf6fd20e75fd96 = function(arr) {
    return Array.from(new Set(arr));
};
function $8f41611a449c55bb$export$485830fe756029f5(obj, pred) {
    return Object.fromEntries(Object.entries(obj).filter(pred));
}
function $8f41611a449c55bb$export$cf80d7b87eda7a5b(obj, pred) {
    return $8f41611a449c55bb$export$485830fe756029f5(obj, function(param) {
        var _param = (0, $7xDhZ._)(param, 2), key = _param[0], _ = _param[1];
        return pred(key);
    });
}
var $8f41611a449c55bb$export$f7404bda8d1e381c = function(template, context) {
    return template.replaceAll(/{(\w+)}/g, function(match, key) {
        var _context_key;
        return (_context_key = context[key]) !== null && _context_key !== void 0 ? _context_key : match;
    });
};
var $8f41611a449c55bb$export$7fbedc92909ed28e = /*#__PURE__*/ function(Map1) {
    "use strict";
    (0, $1cD6J._)(Tree, Map1);
    function Tree(root) {
        var attributes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $hwIvm._)(this, Tree);
        var _this;
        _this = (0, $3KgX2._)(this, Tree), (0, $cYNnT._)(_this, "root", null);
        if (root) _this.setRoot(root, attributes);
        return _this;
    }
    (0, $5knxi._)(Tree, [
        {
            key: "setRoot",
            value: function setRoot(node) {
                var attributes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this.root !== null) throw new Error(`root '${this.root}' already exists`);
                this.set(node, Object.assign(attributes, {
                    children: [],
                    parent: null
                }));
                this.root = node;
            }
        },
        {
            key: "addChild",
            value: function addChild(parent, child) {
                var attributes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this_get_children, _this_get;
                if (this.get(child) !== undefined) throw new Error(`child ${child} already exists`);
                var _this_get_children_push;
                (_this_get_children_push = (_this_get = this.get(parent)) === null || _this_get === void 0 ? void 0 : (_this_get_children = _this_get.children) === null || _this_get_children === void 0 ? void 0 : _this_get_children.push(child)) !== null && _this_get_children_push !== void 0 ? _this_get_children_push : $8f41611a449c55bb$export$8048b892d651b310(`parent '${parent}' does not exist or is malformed`);
                this.set(child, Object.assign(attributes, {
                    children: [],
                    parent: parent
                }));
            }
        },
        {
            key: "deleteNode",
            value: function deleteNode(node) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.get(node).children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        this.deleteNode(child);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.delete(node);
            }
        },
        {
            key: "toObject",
            value: function toObject(morphism) {
                if (typeof morphism === 'function') return Object.fromEntries(Array.from(this, morphism));
                else return Object.fromEntries(this);
            }
        },
        {
            key: "getAncestryOf",
            value: function getAncestryOf(node) {
                var ancestry = [];
                var parent = this.get(node).parent;
                while(parent !== null){
                    ancestry.unshift(parent);
                    parent = this.get(parent).parent;
                }
                return ancestry;
            }
        }
    ], [
        {
            key: "cata",
            value: // I don't trust this algorithm. Does it have bugs? Is it efficient? Does it cover all edge
            //   cases? No clue. But it's not recursive.
            // Collapses `tree` into a single value using an accumulator function `f` (similar to `reduce`)
            //   optionally starting at subtree `node`. `f` is passed each node except the node's
            //   `children` attribute instead holds the results of applying `f` to the node's children.
            function cata(tree) {
                var node = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, f = arguments.length > 2 ? arguments[2] : void 0;
                var newLayer = function(node) {
                    return {
                        node: node,
                        before: (0, $1OMRv._)(tree.get(node).children),
                        after: []
                    };
                };
                var stack = [
                    newLayer(node !== null && node !== void 0 ? node : tree.root)
                ];
                while(true)if (stack.at(-1).before.length) stack.push(newLayer(stack.at(-1).before.pop()));
                else {
                    var curr = stack.pop();
                    var res = f((0, $gRtWz._)((0, $e5Zy6._)({}, tree.get(curr.node)), {
                        children: curr.after
                    }));
                    if (!stack.length) return res;
                    stack.at(-1).after.push(res);
                }
            }
        },
        {
            key: "fromGraphBfs",
            value: function fromGraphBfs(getChildren, root) {
                var tree = new Tree(root);
                var frontier = [
                    root
                ];
                var addChildOf = function(currentNode) {
                    return function(id) {
                        var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                        if (!tree.has(id)) {
                            frontier.push(id);
                            tree.addChild(currentNode, id, data);
                        }
                    };
                };
                while(frontier.length > 0){
                    var currentNode = frontier.pop();
                    getChildren(addChildOf(currentNode), currentNode);
                }
                return tree;
            }
        }
    ]);
    return Tree;
}((0, $atnJC._)(Map));
var $8f41611a449c55bb$export$42e04a57be803477 = function(doc) {
    return function(templateId) {
        // NOTE importNode works like cloneNode except it upgrades custom elements. Needed because
        //   it works on template contents, unlike customElements.upgrade.
        var template = doc.importNode(doc.getElementById(templateId).content, true);
        // clear the fragment of extraneous nodes that might break things
        // TODO Apply recursively to comments
        Array.from(template.childNodes).forEach(function(el) {
            if (el.nodeName === '#text' && !el.nodeValue.trim() || el.nodeName === '#comment') el.remove();
        });
        return template;
    };
};
function $8f41611a449c55bb$export$5db361593220645(docText) {
    return new DOMParser().parseFromString(docText, "text/html");
}
function $8f41611a449c55bb$export$ac1f1552ea16f7d5(obj, filename) {
    (0, $19YAp.saveAs)(new Blob([
        JSON.stringify(obj)
    ], {
        type: 'application/json'
    }), filename);
}

function $8f41611a449c55bb$export$802132930513888b(armoredPublicKey, text) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $2PJNN._)(function() {
        var _ref, readKey, encrypt, createMessage, _tmp;
        return (0, $39i23._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (parcelRequire("hGaRT"))
                    ];
                case 1:
                    _ref = _state.sent(), readKey = _ref.readKey, encrypt = _ref.encrypt, createMessage = _ref.createMessage;
                    _tmp = {};
                    return [
                        4,
                        createMessage({
                            text: text
                        })
                    ];
                case 2:
                    _tmp.message = _state.sent();
                    return [
                        4,
                        readKey({
                            armoredKey: armoredPublicKey
                        })
                    ];
                case 3:
                    return [
                        4,
                        encrypt.apply(void 0, [
                            (_tmp.encryptionKeys = _state.sent(), _tmp)
                        ])
                    ];
                case 4:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })();
}

});
parcelRegister("e5Zy6", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a43146b09b52c85d$export$71511d61b312f219; });

var $cYNnT = parcelRequire("cYNnT");
function $a43146b09b52c85d$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $cYNnT._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("gRtWz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c468d2c6ec1e3e9a$export$71511d61b312f219; });
function $c468d2c6ec1e3e9a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c468d2c6ec1e3e9a$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $c468d2c6ec1e3e9a$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("19YAp", function(module, exports) {
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})(module.exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, module.exports = g;
});

});

parcelRegister("hGaRT", function(module, exports) {

module.exports = (parcelRequire("2bhLc"))($parcel$resolve("cvggw")).then(function() {
    return parcelRequire('4W4kq');
});

});
parcelRegister("2bhLc", function(module, exports) {
"use strict";

var $3MQhM = parcelRequire("3MQhM");
module.exports = $3MQhM(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("3MQhM", function(module, exports) {
"use strict";
var $2c1e69a33462046d$var$cachedBundles = {};
var $2c1e69a33462046d$var$cachedPreloads = {};
var $2c1e69a33462046d$var$cachedPrefetches = {};
function $2c1e69a33462046d$var$getCache(type) {
    switch(type){
        case 'preload':
            return $2c1e69a33462046d$var$cachedPreloads;
        case 'prefetch':
            return $2c1e69a33462046d$var$cachedPrefetches;
        default:
            return $2c1e69a33462046d$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $2c1e69a33462046d$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("ln5rx", function(module, exports) {
'use strict';

var $jUFbb = parcelRequire("jUFbb");
// Utility
function $f8eff7dcc0e50852$var$isFunction(obj) {
    return !!(obj && obj.constructor && obj.call && obj.apply);
}
function $f8eff7dcc0e50852$var$trueFn() {
    return true;
}
// Globals
var $f8eff7dcc0e50852$var$toUpdate = [];
var $f8eff7dcc0e50852$var$inStream;
var $f8eff7dcc0e50852$var$order = [];
var $f8eff7dcc0e50852$var$orderNextIdx = -1;
var $f8eff7dcc0e50852$var$flushingUpdateQueue = false;
var $f8eff7dcc0e50852$var$flushingStreamValue = false;
function $f8eff7dcc0e50852$var$flushing() {
    return $f8eff7dcc0e50852$var$flushingUpdateQueue || $f8eff7dcc0e50852$var$flushingStreamValue;
}
/** @namespace */ var $f8eff7dcc0e50852$var$flyd = {};
// /////////////////////////// API ///////////////////////////////// //
/**
 * Creates a new stream
 *
 * __Signature__: `a -> Stream a`
 *
 * @name flyd.stream
 * @param {*} initialValue - (Optional) the initial value of the stream
 * @return {stream} the stream
 *
 * @example
 * var n = flyd.stream(1); // Stream with initial value `1`
 * var s = flyd.stream(); // Stream with no initial value
 */ $f8eff7dcc0e50852$var$flyd.stream = function(initialValue) {
    var endStream = $f8eff7dcc0e50852$var$createDependentStream([], $f8eff7dcc0e50852$var$trueFn);
    var s = $f8eff7dcc0e50852$var$createStream();
    s.end = endStream;
    s.fnArgs = [];
    endStream.listeners.push(s);
    if (arguments.length > 0) s(initialValue);
    return s;
};
// fantasy-land Applicative
$f8eff7dcc0e50852$var$flyd.stream['fantasy-land/of'] = $f8eff7dcc0e50852$var$flyd.stream.of = $f8eff7dcc0e50852$var$flyd.stream;
/**
 * Create a new dependent stream
 *
 * __Signature__: `(...Stream * -> Stream b -> b) -> [Stream *] -> Stream b`
 *
 * @name flyd.combine
 * @param {Function} fn - the function used to combine the streams
 * @param {Array<stream>} dependencies - the streams that this one depends on
 * @return {stream} the dependent stream
 *
 * @example
 * var n1 = flyd.stream(0);
 * var n2 = flyd.stream(0);
 * var max = flyd.combine(function(n1, n2, self, changed) {
 *   return n1() > n2() ? n1() : n2();
 * }, [n1, n2]);
 */ $f8eff7dcc0e50852$var$flyd.combine = $jUFbb(2, $f8eff7dcc0e50852$var$combine);
function $f8eff7dcc0e50852$var$combine(fn, streams) {
    var i, s, deps, depEndStreams;
    var endStream = $f8eff7dcc0e50852$var$createDependentStream([], $f8eff7dcc0e50852$var$trueFn);
    deps = [];
    depEndStreams = [];
    for(i = 0; i < streams.length; ++i)if (streams[i] !== undefined) {
        deps.push(streams[i]);
        if (streams[i].end !== undefined) depEndStreams.push(streams[i].end);
    }
    s = $f8eff7dcc0e50852$var$createDependentStream(deps, fn);
    s.depsChanged = [];
    s.fnArgs = s.deps.concat([
        s,
        s.depsChanged
    ]);
    s.end = endStream;
    endStream.listeners.push(s);
    $f8eff7dcc0e50852$var$addListeners(depEndStreams, endStream);
    endStream.deps = depEndStreams;
    $f8eff7dcc0e50852$var$updateStream(s);
    return s;
}
/**
 * Returns `true` if the supplied argument is a Flyd stream and `false` otherwise.
 *
 * __Signature__: `* -> Boolean`
 *
 * @name flyd.isStream
 * @param {*} value - the value to test
 * @return {Boolean} `true` if is a Flyd streamn, `false` otherwise
 *
 * @example
 * var s = flyd.stream(1);
 * var n = 1;
 * flyd.isStream(s); //=> true
 * flyd.isStream(n); //=> false
 */ $f8eff7dcc0e50852$var$flyd.isStream = function(stream) {
    return $f8eff7dcc0e50852$var$isFunction(stream) && 'hasVal' in stream;
};
/**
 * Invokes the body (the function to calculate the value) of a dependent stream
 *
 * By default the body of a dependent stream is only called when all the streams
 * upon which it depends has a value. `immediate` can circumvent this behaviour.
 * It immediately invokes the body of a dependent stream.
 *
 * __Signature__: `Stream a -> Stream a`
 *
 * @name flyd.immediate
 * @param {stream} stream - the dependent stream
 * @return {stream} the same stream
 *
 * @example
 * var s = flyd.stream();
 * var hasItems = flyd.immediate(flyd.combine(function(s) {
 *   return s() !== undefined && s().length > 0;
 * }, [s]);
 * console.log(hasItems()); // logs `false`. Had `immediate` not been
 *                          // used `hasItems()` would've returned `undefined`
 * s([1]);
 * console.log(hasItems()); // logs `true`.
 * s([]);
 * console.log(hasItems()); // logs `false`.
 */ $f8eff7dcc0e50852$var$flyd.immediate = function(s) {
    if (s.depsMet === false) {
        s.depsMet = true;
        $f8eff7dcc0e50852$var$updateStream(s);
    }
    return s;
};
/**
 * Changes which `endsStream` should trigger the ending of `s`.
 *
 * __Signature__: `Stream a -> Stream b -> Stream b`
 *
 * @name flyd.endsOn
 * @param {stream} endStream - the stream to trigger the ending
 * @param {stream} stream - the stream to be ended by the endStream
 * @param {stream} the stream modified to be ended by endStream
 *
 * @example
 * var n = flyd.stream(1);
 * var killer = flyd.stream();
 * // `double` ends when `n` ends or when `killer` emits any value
 * var double = flyd.endsOn(flyd.merge(n.end, killer), flyd.combine(function(n) {
 *   return 2 * n();
 * }, [n]);
*/ $f8eff7dcc0e50852$var$flyd.endsOn = function(endS, s) {
    $f8eff7dcc0e50852$var$detachDeps(s.end);
    endS.listeners.push(s.end);
    s.end.deps.push(endS);
    return s;
};
/**
 * Map a stream
 *
 * Returns a new stream consisting of every value from `s` passed through
 * `fn`. I.e. `map` creates a new stream that listens to `s` and
 * applies `fn` to every new value.
 * __Signature__: `(a -> result) -> Stream a -> Stream result`
 *
 * @name flyd.map
 * @param {Function} fn - the function that produces the elements of the new stream
 * @param {stream} stream - the stream to map
 * @return {stream} a new stream with the mapped values
 *
 * @example
 * var numbers = flyd.stream(0);
 * var squaredNumbers = flyd.map(function(n) { return n*n; }, numbers);
 */ // Library functions use self callback to accept (null, undefined) update triggers.
function $f8eff7dcc0e50852$var$map(f, s) {
    return $f8eff7dcc0e50852$var$combine(function(s, self) {
        self(f(s.val));
    }, [
        s
    ]);
}
$f8eff7dcc0e50852$var$flyd.map = $jUFbb(2, $f8eff7dcc0e50852$var$map);
/**
 * Chain a stream
 *
 * also known as flatMap
 *
 * Where `fn` returns a stream this function will flatten the resulting streams.
 * Every time `fn` is called the context of the returned stream will "switch" to that stream.
 *
 * __Signature__: `(a -> Stream b) -> Stream a -> Stream b`
 *
 * @name flyd.chain
 * @param {Function} fn - the function that produces the streams to be flattened
 * @param {stream} stream - the stream to map
 * @return {stream} a new stream with the mapped values
 *
 * @example
 * var filter = flyd.stream('who');
 * var items = flyd.chain(function(filter){
 *   return flyd.stream(findUsers(filter));
 * }, filter);
 */ $f8eff7dcc0e50852$var$flyd.chain = $jUFbb(2, $f8eff7dcc0e50852$var$chain);
/**
 * Apply a stream
 *
 * Applies the value in `s2` to the function in `s1`.
 *
 * __Signature__: `Stream (a -> b) -> Stream a -> Stream b`
 *
 * @name flyd.ap
 * @param {stream} s1 - The value to be applied
 * @param {stream} s2 - The function expecting the value
 * @return {stream} a new stream with the mapped values
 *
 * @example
 * var add = stream(a => b => a + b)
 * var n1 = stream(1)
 * var n2 = stream(2)
 *
 * var added = flyd.ap(n2, flyd.ap(n1, add)) // stream(3)
 * // can also be written using pipe
 * var added_pipe = add
 *   .pipe(ap(n1))
 *   .pipe(ap(n2));
 * added_pipe() // 3
 */ $f8eff7dcc0e50852$var$flyd.ap = $jUFbb(2, $f8eff7dcc0e50852$var$ap);
/**
 * Listen to stream events
 *
 * Similar to `map` except that the returned stream is empty. Use `on` for doing
 * side effects in reaction to stream changes. Use the returned stream only if you
 * need to manually end it.
 *
 * __Signature__: `(a -> result) -> Stream a -> Stream undefined`
 *
 * @name flyd.on
 * @param {Function} cb - the callback
 * @param {stream} stream - the stream
 * @return {stream} an empty stream (can be ended)
 */ $f8eff7dcc0e50852$var$flyd.on = $jUFbb(2, function(f, s) {
    return $f8eff7dcc0e50852$var$combine(function(s) {
        f(s.val);
    }, [
        s
    ]);
});
/**
 * Creates a new stream with the results of calling the function on every incoming
 * stream with and accumulator and the incoming value.
 *
 * __Signature__: `(a -> b -> a) -> a -> Stream b -> Stream a`
 *
 * @name flyd.scan
 * @param {Function} fn - the function to call
 * @param {*} val - the initial value of the accumulator
 * @param {stream} stream - the stream source
 * @return {stream} the new stream
 *
 * @example
 * var numbers = flyd.stream();
 * var sum = flyd.scan(function(sum, n) { return sum+n; }, 0, numbers);
 * numbers(2)(3)(5);
 * sum(); // 10
 */ $f8eff7dcc0e50852$var$flyd.scan = $jUFbb(3, function(f, acc, s) {
    var ns = $f8eff7dcc0e50852$var$combine(function(s, self) {
        self(acc = f(acc, s.val));
    }, [
        s
    ]);
    if (!ns.hasVal) ns(acc);
    return ns;
});
/**
 * Creates a new stream down which all values from both `stream1` and `stream2`
 * will be sent.
 *
 * __Signature__: `Stream a -> Stream a -> Stream a`
 *
 * @name flyd.merge
 * @param {stream} source1 - one stream to be merged
 * @param {stream} source2 - the other stream to be merged
 * @return {stream} a stream with the values from both sources
 *
 * @example
 * var btn1Clicks = flyd.stream();
 * button1Elm.addEventListener(btn1Clicks);
 * var btn2Clicks = flyd.stream();
 * button2Elm.addEventListener(btn2Clicks);
 * var allClicks = flyd.merge(btn1Clicks, btn2Clicks);
 */ $f8eff7dcc0e50852$var$flyd.merge = $jUFbb(2, function(s1, s2) {
    var s = $f8eff7dcc0e50852$var$flyd.immediate($f8eff7dcc0e50852$var$combine(function(s1, s2, self, changed) {
        if (changed[0]) self(changed[0]());
        else if (s1.hasVal) self(s1.val);
        else if (s2.hasVal) self(s2.val);
    }, [
        s1,
        s2
    ]));
    $f8eff7dcc0e50852$var$flyd.endsOn($f8eff7dcc0e50852$var$combine(function() {
        return true;
    }, [
        s1.end,
        s2.end
    ]), s);
    return s;
});
/**
 * Creates a new stream resulting from applying `transducer` to `stream`.
 *
 * __Signature__: `Transducer -> Stream a -> Stream b`
 *
 * @name flyd.transduce
 * @param {Transducer} xform - the transducer transformation
 * @param {stream} source - the stream source
 * @return {stream} the new stream
 *
 * @example
 * var t = require('transducers.js');
 *
 * var results = [];
 * var s1 = flyd.stream();
 * var tx = t.compose(t.map(function(x) { return x * 2; }), t.dedupe());
 * var s2 = flyd.transduce(tx, s1);
 * flyd.combine(function(s2) { results.push(s2()); }, [s2]);
 * s1(1)(1)(2)(3)(3)(3)(4);
 * results; // => [2, 4, 6, 8]
 */ $f8eff7dcc0e50852$var$flyd.transduce = $jUFbb(2, function(xform, source) {
    xform = xform(new $f8eff7dcc0e50852$var$StreamTransformer());
    return $f8eff7dcc0e50852$var$combine(function(source, self) {
        var res = xform['@@transducer/step'](undefined, source.val);
        if (res && res['@@transducer/reduced'] === true) {
            self.end(true);
            return res['@@transducer/value'];
        } else return res;
    }, [
        source
    ]);
});
/**
 * Returns `fn` curried to `n`. Use this function to curry functions exposed by
 * modules for Flyd.
 *
 * @name flyd.curryN
 * @function
 * @param {Integer} arity - the function arity
 * @param {Function} fn - the function to curry
 * @return {Function} the curried function
 *
 * @example
 * function add(x, y) { return x + y; };
 * var a = flyd.curryN(2, add);
 * a(2)(4) // => 6
 */ $f8eff7dcc0e50852$var$flyd.curryN = $jUFbb;
/**
 * Returns a new stream identical to the original except every
 * value will be passed through `f`.
 *
 * _Note:_ This function is included in order to support the fantasy land
 * specification.
 *
 * __Signature__: Called bound to `Stream a`: `(a -> b) -> Stream b`
 *
 * @name stream.map
 * @param {Function} function - the function to apply
 * @return {stream} a new stream with the values mapped
 *
 * @example
 * var numbers = flyd.stream(0);
 * var squaredNumbers = numbers.map(function(n) { return n*n; });
 */ function $f8eff7dcc0e50852$var$boundMap(f) {
    return $f8eff7dcc0e50852$var$map(f, this);
}
/**
 * Returns the result of applying function `fn` to this stream
 *
 * __Signature__: Called bound to `Stream a`: `(a -> Stream b) -> Stream b`
 *
 * @name stream.pipe
 * @param {Function} fn - the function to apply
 * @return {stream} A new stream
 *
 * @example
 * var numbers = flyd.stream(0);
 * var squaredNumbers = numbers.pipe(flyd.map(function(n){ return n*n; }));
 */ function $f8eff7dcc0e50852$var$operator_pipe(f) {
    return f(this);
}
function $f8eff7dcc0e50852$var$boundChain(f) {
    return $f8eff7dcc0e50852$var$chain(f, this);
}
function $f8eff7dcc0e50852$var$chain(f, s) {
    // Internal state to end flat map stream
    var flatEnd = $f8eff7dcc0e50852$var$flyd.stream(1);
    var internalEnded = $f8eff7dcc0e50852$var$flyd.on(function() {
        var alive = flatEnd() - 1;
        flatEnd(alive);
        if (alive <= 0) flatEnd.end(true);
    });
    internalEnded(s.end);
    var last = $f8eff7dcc0e50852$var$flyd.stream();
    var flatStream = $f8eff7dcc0e50852$var$flyd.combine(function(s, own) {
        last.end(true);
        // Our fn stream makes streams
        var newS = f(s());
        flatEnd(flatEnd() + 1);
        internalEnded(newS.end);
        // Update self on call -- newS is never handed out so deps don't matter
        last = $f8eff7dcc0e50852$var$map(own, newS);
    }, [
        s
    ]);
    $f8eff7dcc0e50852$var$flyd.endsOn(flatEnd.end, flatStream);
    return flatStream;
}
$f8eff7dcc0e50852$var$flyd.fromPromise = function fromPromise(p) {
    var s = $f8eff7dcc0e50852$var$flyd.stream();
    p.then(function(val) {
        s(val);
        s.end(true);
    });
    return s;
};
$f8eff7dcc0e50852$var$flyd.flattenPromise = function flattenPromise(s) {
    return $f8eff7dcc0e50852$var$combine(function(s, self) {
        s().then(self);
    }, [
        s
    ]);
};
/**
 * Returns a new stream which is the result of applying the
 * functions from `this` stream to the values in `stream` parameter.
 *
 * `this` stream must be a stream of functions.
 *
 * _Note:_ This function is included in order to support the fantasy land
 * specification.
 *
 * __Signature__: Called bound to `Stream (a -> b)`: `a -> Stream b`
 *
 * @name stream.ap
 * @param {stream} stream - the values stream
 * @return {stream} a new stream with the functions applied to values
 *
 * @example
 * var add = flyd.curryN(2, function(x, y) { return x + y; });
 * var numbers1 = flyd.stream();
 * var numbers2 = flyd.stream();
 * var addToNumbers1 = flyd.map(add, numbers1);
 * var added = addToNumbers1.ap(numbers2);
 */ function $f8eff7dcc0e50852$var$ap(s2, s1) {
    return $f8eff7dcc0e50852$var$combine(function(s1, s2, self) {
        self(s1.val(s2.val));
    }, [
        s1,
        s2
    ]);
}
function $f8eff7dcc0e50852$var$boundAp(s2) {
    return $f8eff7dcc0e50852$var$ap(s2, this);
}
/**
 * @private
 */ function $f8eff7dcc0e50852$var$fantasy_land_ap(s1) {
    return $f8eff7dcc0e50852$var$ap(this, s1);
}
/**
 * Get a human readable view of a stream
 * @name stream.toString
 * @return {String} the stream string representation
 */ function $f8eff7dcc0e50852$var$streamToString() {
    return 'stream(' + this.val + ')';
}
/**
 * @name stream.end
 * @memberof stream
 * A stream that emits `true` when the stream ends. If `true` is pushed down the
 * stream the parent stream ends.
 */ /**
 * @name stream.of
 * @function
 * @memberof stream
 * Returns a new stream with `value` as its initial value. It is identical to
 * calling `flyd.stream` with one argument.
 *
 * __Signature__: Called bound to `Stream (a)`: `b -> Stream b`
 *
 * @param {*} value - the initial value
 * @return {stream} the new stream
 *
 * @example
 * var n = flyd.stream(1);
 * var m = n.of(1);
 */ // /////////////////////////// PRIVATE ///////////////////////////////// //
/**
 * @private
 * Create a stream with no dependencies and no value
 * @return {Function} a flyd stream
 */ function $f8eff7dcc0e50852$var$createStream() {
    function s(n) {
        if (arguments.length === 0) return s.val;
        $f8eff7dcc0e50852$var$updateStreamValue(n, s);
        return s;
    }
    s.hasVal = false;
    s.val = undefined;
    s.updaters = [];
    s.listeners = [];
    s.queued = false;
    s.end = undefined;
    // fantasy-land compatibility
    s.ap = $f8eff7dcc0e50852$var$boundAp;
    s['fantasy-land/map'] = s.map = $f8eff7dcc0e50852$var$boundMap;
    s['fantasy-land/ap'] = $f8eff7dcc0e50852$var$fantasy_land_ap;
    s['fantasy-land/of'] = s.of = $f8eff7dcc0e50852$var$flyd.stream;
    s['fantasy-land/chain'] = s.chain = $f8eff7dcc0e50852$var$boundChain;
    s.pipe = $f8eff7dcc0e50852$var$operator_pipe;
    // According to the fantasy-land Applicative specification
    // Given a value f, one can access its type representative via the constructor property:
    // `f.constructor.of`
    s.constructor = $f8eff7dcc0e50852$var$flyd.stream;
    s.toJSON = function() {
        return s.val;
    };
    s.toString = $f8eff7dcc0e50852$var$streamToString;
    return s;
}
/**
 * @private
 * Create a dependent stream
 * @param {Array<stream>} dependencies - an array of the streams
 * @param {Function} fn - the function used to calculate the new stream value
 * from the dependencies
 * @return {stream} the created stream
 */ function $f8eff7dcc0e50852$var$createDependentStream(deps, fn) {
    var s = $f8eff7dcc0e50852$var$createStream();
    s.fn = fn;
    s.deps = deps;
    s.depsMet = false;
    s.depsChanged = deps.length > 0 ? [] : undefined;
    s.shouldUpdate = false;
    $f8eff7dcc0e50852$var$addListeners(deps, s);
    return s;
}
/**
 * @private
 * Check if all the dependencies have values
 * @param {stream} stream - the stream to check depencencies from
 * @return {Boolean} `true` if all dependencies have vales, `false` otherwise
 */ function $f8eff7dcc0e50852$var$initialDependenciesMet(stream) {
    stream.depsMet = stream.deps.every(function(s) {
        return s.hasVal;
    });
    return stream.depsMet;
}
function $f8eff7dcc0e50852$var$dependenciesAreMet(stream) {
    return stream.depsMet === true || $f8eff7dcc0e50852$var$initialDependenciesMet(stream);
}
function $f8eff7dcc0e50852$var$isEnded(stream) {
    return stream.end && stream.end.val === true;
}
function $f8eff7dcc0e50852$var$listenersNeedUpdating(s) {
    return s.listeners.some(function(s) {
        return s.shouldUpdate;
    });
}
/**
 * @private
 * Update a dependent stream using its dependencies in an atomic way
 * @param {stream} stream - the stream to update
 */ function $f8eff7dcc0e50852$var$updateStream(s) {
    if ($f8eff7dcc0e50852$var$isEnded(s) || !$f8eff7dcc0e50852$var$dependenciesAreMet(s)) return;
    if ($f8eff7dcc0e50852$var$inStream !== undefined) {
        $f8eff7dcc0e50852$var$updateLaterUsing($f8eff7dcc0e50852$var$updateStream, s);
        return;
    }
    $f8eff7dcc0e50852$var$inStream = s;
    if (s.depsChanged) s.fnArgs[s.fnArgs.length - 1] = s.depsChanged;
    var returnVal = s.fn.apply(s.fn, s.fnArgs);
    if (returnVal !== undefined) s(returnVal);
    $f8eff7dcc0e50852$var$inStream = undefined;
    if (s.depsChanged !== undefined) s.depsChanged = [];
    s.shouldUpdate = false;
    if ($f8eff7dcc0e50852$var$flushing() === false) $f8eff7dcc0e50852$var$flushUpdate();
    if ($f8eff7dcc0e50852$var$listenersNeedUpdating(s)) {
        if (!$f8eff7dcc0e50852$var$flushingStreamValue) s(s.val);
        else s.listeners.forEach(function(listener) {
            if (listener.shouldUpdate) $f8eff7dcc0e50852$var$updateLaterUsing($f8eff7dcc0e50852$var$updateStream, listener);
        });
    }
}
/**
 * @private
 * Update the dependencies of a stream
 * @param {stream} stream
 */ function $f8eff7dcc0e50852$var$updateListeners(s) {
    var i, o, list;
    var listeners = s.listeners;
    for(i = 0; i < listeners.length; ++i){
        list = listeners[i];
        if (list.end === s) $f8eff7dcc0e50852$var$endStream(list);
        else {
            if (list.depsChanged !== undefined) list.depsChanged.push(s);
            list.shouldUpdate = true;
            $f8eff7dcc0e50852$var$findDeps(list);
        }
    }
    for(; $f8eff7dcc0e50852$var$orderNextIdx >= 0; --$f8eff7dcc0e50852$var$orderNextIdx){
        o = $f8eff7dcc0e50852$var$order[$f8eff7dcc0e50852$var$orderNextIdx];
        if (o.shouldUpdate === true) $f8eff7dcc0e50852$var$updateStream(o);
        o.queued = false;
    }
}
/**
 * @private
 * Add stream dependencies to the global `order` queue.
 * @param {stream} stream
 * @see updateDeps
 */ function $f8eff7dcc0e50852$var$findDeps(s) {
    var i;
    var listeners = s.listeners;
    if (s.queued === false) {
        s.queued = true;
        for(i = 0; i < listeners.length; ++i)$f8eff7dcc0e50852$var$findDeps(listeners[i]);
        $f8eff7dcc0e50852$var$order[++$f8eff7dcc0e50852$var$orderNextIdx] = s;
    }
}
function $f8eff7dcc0e50852$var$updateLaterUsing(updater, stream) {
    $f8eff7dcc0e50852$var$toUpdate.push(stream);
    stream.updaters.push(updater);
    stream.shouldUpdate = true;
}
/**
 * @private
 */ function $f8eff7dcc0e50852$var$flushUpdate() {
    $f8eff7dcc0e50852$var$flushingUpdateQueue = true;
    while($f8eff7dcc0e50852$var$toUpdate.length > 0){
        var stream = $f8eff7dcc0e50852$var$toUpdate.shift();
        var nextUpdateFn = stream.updaters.shift();
        if (nextUpdateFn && stream.shouldUpdate) nextUpdateFn(stream);
    }
    $f8eff7dcc0e50852$var$flushingUpdateQueue = false;
}
/**
 * @private
 * Push down a value into a stream
 * @param {stream} stream
 * @param {*} value
 */ function $f8eff7dcc0e50852$var$updateStreamValue(n, s) {
    s.val = n;
    s.hasVal = true;
    if ($f8eff7dcc0e50852$var$inStream === undefined) {
        $f8eff7dcc0e50852$var$flushingStreamValue = true;
        $f8eff7dcc0e50852$var$updateListeners(s);
        if ($f8eff7dcc0e50852$var$toUpdate.length > 0) $f8eff7dcc0e50852$var$flushUpdate();
        $f8eff7dcc0e50852$var$flushingStreamValue = false;
    } else if ($f8eff7dcc0e50852$var$inStream === s) $f8eff7dcc0e50852$var$markListeners(s, s.listeners);
    else $f8eff7dcc0e50852$var$updateLaterUsing(function(s) {
        $f8eff7dcc0e50852$var$updateStreamValue(n, s);
    }, s);
}
/**
 * @private
 */ function $f8eff7dcc0e50852$var$markListeners(s, lists) {
    var i, list;
    for(i = 0; i < lists.length; ++i){
        list = lists[i];
        if (list.end !== s) {
            if (list.depsChanged !== undefined) list.depsChanged.push(s);
            list.shouldUpdate = true;
        } else $f8eff7dcc0e50852$var$endStream(list);
    }
}
/**
 * @private
 * Add dependencies to a stream
 * @param {Array<stream>} dependencies
 * @param {stream} stream
 */ function $f8eff7dcc0e50852$var$addListeners(deps, s) {
    for(var i = 0; i < deps.length; ++i)deps[i].listeners.push(s);
}
/**
 * @private
 * Removes an stream from a dependency array
 * @param {stream} stream
 * @param {Array<stream>} dependencies
 */ function $f8eff7dcc0e50852$var$removeListener(s, listeners) {
    var idx = listeners.indexOf(s);
    listeners[idx] = listeners[listeners.length - 1];
    listeners.length--;
}
/**
 * @private
 * Detach a stream from its dependencies
 * @param {stream} stream
 */ function $f8eff7dcc0e50852$var$detachDeps(s) {
    for(var i = 0; i < s.deps.length; ++i)$f8eff7dcc0e50852$var$removeListener(s, s.deps[i].listeners);
    s.deps.length = 0;
}
/**
 * @private
 * Ends a stream
 */ function $f8eff7dcc0e50852$var$endStream(s) {
    if (s.deps !== undefined) $f8eff7dcc0e50852$var$detachDeps(s);
    if (s.end !== undefined) $f8eff7dcc0e50852$var$detachDeps(s.end);
}
/**
 * @private
 */ /**
 * @private
 * transducer stream transformer
 */ function $f8eff7dcc0e50852$var$StreamTransformer() {}
$f8eff7dcc0e50852$var$StreamTransformer.prototype['@@transducer/init'] = function() {};
$f8eff7dcc0e50852$var$StreamTransformer.prototype['@@transducer/result'] = function() {};
$f8eff7dcc0e50852$var$StreamTransformer.prototype['@@transducer/step'] = function(s, v) {
    return v;
};
module.exports = $f8eff7dcc0e50852$var$flyd;

});
parcelRegister("jUFbb", function(module, exports) {

var $jrOAX = parcelRequire("jrOAX");

var $7sJyH = parcelRequire("7sJyH");

var $7IBWQ = parcelRequire("7IBWQ");

var $69ymr = parcelRequire("69ymr");
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      var sumArgs = (...args) => R.sum(args);
 *
 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */ var $e7f330a9a8037920$var$curryN = /*#__PURE__*/ $7IBWQ(function curryN(length, fn) {
    if (length === 1) return $7sJyH(fn);
    return $jrOAX(length, $69ymr(length, [], fn));
});
module.exports = $e7f330a9a8037920$var$curryN;

});
parcelRegister("jrOAX", function(module, exports) {
function $e287c90cd8e64a61$var$_arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
}
module.exports = $e287c90cd8e64a61$var$_arity;

});

parcelRegister("7sJyH", function(module, exports) {

var $5bhFk = parcelRequire("5bhFk");
/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $56ee7cf2427d6842$var$_curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || $5bhFk(a)) return f1;
        else return fn.apply(this, arguments);
    };
}
module.exports = $56ee7cf2427d6842$var$_curry1;

});
parcelRegister("5bhFk", function(module, exports) {
function $3c5baed3820547d1$var$_isPlaceholder(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}
module.exports = $3c5baed3820547d1$var$_isPlaceholder;

});


parcelRegister("7IBWQ", function(module, exports) {

var $7sJyH = parcelRequire("7sJyH");

var $5bhFk = parcelRequire("5bhFk");
/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $59ea142bfe1c7fe4$var$_curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return $5bhFk(a) ? f2 : $7sJyH(function(_b) {
                    return fn(a, _b);
                });
            default:
                return $5bhFk(a) && $5bhFk(b) ? f2 : $5bhFk(a) ? $7sJyH(function(_a) {
                    return fn(_a, b);
                }) : $5bhFk(b) ? $7sJyH(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}
module.exports = $59ea142bfe1c7fe4$var$_curry2;

});

parcelRegister("69ymr", function(module, exports) {

var $jrOAX = parcelRequire("jrOAX");

var $5bhFk = parcelRequire("5bhFk");
/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $47ae3cb6fe975576$var$_curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!$5bhFk(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!$5bhFk(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : $jrOAX(left, $47ae3cb6fe975576$var$_curryN(length, combined, fn));
    };
}
module.exports = $47ae3cb6fe975576$var$_curryN;

});



parcelRegister("8b7cE", function(module, exports) {

$parcel$export(module.exports, "dropRepeats", function () { return $5f44f02e0f38e107$export$f42b5f849eadee29; }, function (v) { return $5f44f02e0f38e107$export$f42b5f849eadee29 = v; });
var $5f44f02e0f38e107$export$f42b5f849eadee29;
var $5f44f02e0f38e107$export$a047232242a2c3d2;

var $ln5rx = parcelRequire("ln5rx");
function $5f44f02e0f38e107$var$dropRepeatsWith(eq, s) {
    var prev;
    return $ln5rx.combine(function(s, self) {
        if (!self.hasVal || !eq(s.val, prev)) {
            self(s.val);
            prev = s.val;
        }
    }, [
        s
    ]);
}
$5f44f02e0f38e107$export$f42b5f849eadee29 = function(s) {
    return $5f44f02e0f38e107$var$dropRepeatsWith($5f44f02e0f38e107$var$strictEq, s);
};
$5f44f02e0f38e107$export$a047232242a2c3d2 = $ln5rx.curryN(2, $5f44f02e0f38e107$var$dropRepeatsWith);
function $5f44f02e0f38e107$var$strictEq(a, b) {
    return a === b;
}

});


parcelRegister("aGmIr", function(module, exports) {
module.exports = "-----BEGIN PGP PUBLIC KEY BLOCK-----\n\nxjMEYf8cKBYJKwYBBAHaRw8BAQdAHE6JBN/PRr/7ZLFhb5vLLrKSWJLXxNpG\nMbqVZccBAL3NOVdpY2tlZFdpdGNoNkBwcm90b25tYWlsLmNvbSA8V2lja2Vk\nV2l0Y2g2QHByb3Rvbm1haWwuY29tPsKPBBAWCgAgBQJh/xwoBgsJBwgDAgQV\nCAoCBBYCAQACGQECGwMCHgEAIQkQ4GeD5hotLgUWIQTKTXvpnWFrweQb09Dg\nZ4PmGi0uBSUaAP44QKmwpTeK+oioSWo3qY4TpfXcz7d4qi49tmADmb6G8QEA\n1FEUMJllc9Qq3xiACBY/O5XIXsAlLlu1cAe2vkNcKgTOOARh/xwoEgorBgEE\nAZdVAQUBAQdAPj3oEz8PeUhGvxXZ4CYy8ejL/SiS8gyWPlAI2f2RWn4DAQgH\nwngEGBYIAAkFAmH/HCgCGwwAIQkQ4GeD5hotLgUWIQTKTXvpnWFrweQb09Dg\nZ4PmGi0uBf9zAP9tggzcytwB2XGu2c50Pfa0IZSEEiWnhN2A7uQRtqAKNAD/\nRQPybgO7rHpk9XjjHvqk87NYWAkj2kCCgK5rK+cYjwk=\n=9jDO\n-----END PGP PUBLIC KEY BLOCK-----\n";

});

parcelRegister("kalkp", function(module, exports) {
/**
 * @fileOverview Contains definition of the core graph object.
 */ // TODO: need to change storage layer:
// 1. Be able to get all nodes O(1)
// 2. Be able to get number of links O(1)
/**
 * @example
 *  var graph = require('ngraph.graph')();
 *  graph.addNode(1);     // graph has one node.
 *  graph.addLink(2, 3);  // now graph contains three nodes and one link.
 *
 */ module.exports = $eae549276f7353b3$var$createGraph;

var $5CkbI = parcelRequire("5CkbI");
/**
 * Creates a new graph
 */ function $eae549276f7353b3$var$createGraph(options) {
    // Graph structure is maintained as dictionary of nodes
    // and array of links. Each node has 'links' property which
    // hold all links related to that node. And general links
    // array is used to speed up all links enumeration. This is inefficient
    // in terms of memory, but simplifies coding.
    options = options || {};
    if ('uniqueLinkId' in options) {
        console.warn("ngraph.graph: Starting from version 0.14 `uniqueLinkId` is deprecated.\nUse `multigraph` option instead\n", '\n', "Note: there is also change in default behavior: From now on each graph\nis considered to be not a multigraph by default (each edge is unique).");
        options.multigraph = options.uniqueLinkId;
    }
    // Dear reader, the non-multigraphs do not guarantee that there is only
    // one link for a given pair of node. When this option is set to false
    // we can save some memory and CPU (18% faster for non-multigraph);
    if (options.multigraph === undefined) options.multigraph = false;
    if (typeof Map !== 'function') // TODO: Should we polyfill it ourselves? We don't use much operations there..
    throw new Error('ngraph.graph requires `Map` to be defined. Please polyfill it before using ngraph');
    var nodes = new Map();
    var links = [], // Hash of multi-edges. Used to track ids of edges between same nodes
    multiEdges = {}, suspendEvents = 0, createLink = options.multigraph ? createUniqueLink : createSingleLink, // Our graph API provides means to listen to graph changes. Users can subscribe
    // to be notified about changes in the graph by using `on` method. However
    // in some cases they don't use it. To avoid unnecessary memory consumption
    // we will not record graph changes until we have at least one subscriber.
    // Code below supports this optimization.
    //
    // Accumulates all changes made during graph updates.
    // Each change element contains:
    //  changeType - one of the strings: 'add', 'remove' or 'update';
    //  node - if change is related to node this property is set to changed graph's node;
    //  link - if change is related to link this property is set to changed graph's link;
    changes = [], recordLinkChange = noop, recordNodeChange = noop, enterModification = noop, exitModification = noop;
    // this is our public API:
    var graphPart = {
        /**
     * Adds node to the graph. If node with given id already exists in the graph
     * its data is extended with whatever comes in 'data' argument.
     *
     * @param nodeId the node's identifier. A string or number is preferred.
     * @param [data] additional data for the node being added. If node already
     *   exists its data object is augmented with the new one.
     *
     * @return {node} The newly added node or node with given id if it already exists.
     */ addNode: addNode,
        /**
     * Adds a link to the graph. The function always create a new
     * link between two nodes. If one of the nodes does not exists
     * a new node is created.
     *
     * @param fromId link start node id;
     * @param toId link end node id;
     * @param [data] additional data to be set on the new link;
     *
     * @return {link} The newly created link
     */ addLink: addLink,
        /**
     * Removes link from the graph. If link does not exist does nothing.
     *
     * @param link - object returned by addLink() or getLinks() methods.
     *
     * @returns true if link was removed; false otherwise.
     */ removeLink: removeLink,
        /**
     * Removes node with given id from the graph. If node does not exist in the graph
     * does nothing.
     *
     * @param nodeId node's identifier passed to addNode() function.
     *
     * @returns true if node was removed; false otherwise.
     */ removeNode: removeNode,
        /**
     * Gets node with given identifier. If node does not exist undefined value is returned.
     *
     * @param nodeId requested node identifier;
     *
     * @return {node} in with requested identifier or undefined if no such node exists.
     */ getNode: getNode,
        /**
     * Gets number of nodes in this graph.
     *
     * @return number of nodes in the graph.
     */ getNodeCount: getNodeCount,
        /**
     * Gets total number of links in the graph.
     */ getLinkCount: getLinkCount,
        /**
     * Synonym for `getLinkCount()`
     */ getLinksCount: getLinkCount,
        /**
     * Synonym for `getNodeCount()`
     */ getNodesCount: getNodeCount,
        /**
     * Gets all links (inbound and outbound) from the node with given id.
     * If node with given id is not found null is returned.
     *
     * @param nodeId requested node identifier.
     *
     * @return Array of links from and to requested node if such node exists;
     *   otherwise null is returned.
     */ getLinks: getLinks,
        /**
     * Invokes callback on each node of the graph.
     *
     * @param {Function(node)} callback Function to be invoked. The function
     *   is passed one argument: visited node.
     */ forEachNode: forEachNode,
        /**
     * Invokes callback on every linked (adjacent) node to the given one.
     *
     * @param nodeId Identifier of the requested node.
     * @param {Function(node, link)} callback Function to be called on all linked nodes.
     *   The function is passed two parameters: adjacent node and link object itself.
     * @param oriented if true graph treated as oriented.
     */ forEachLinkedNode: forEachLinkedNode,
        /**
     * Enumerates all links in the graph
     *
     * @param {Function(link)} callback Function to be called on all links in the graph.
     *   The function is passed one parameter: graph's link object.
     *
     * Link object contains at least the following fields:
     *  fromId - node id where link starts;
     *  toId - node id where link ends,
     *  data - additional data passed to graph.addLink() method.
     */ forEachLink: forEachLink,
        /**
     * Suspend all notifications about graph changes until
     * endUpdate is called.
     */ beginUpdate: enterModification,
        /**
     * Resumes all notifications about graph changes and fires
     * graph 'changed' event in case there are any pending changes.
     */ endUpdate: exitModification,
        /**
     * Removes all nodes and links from the graph.
     */ clear: clear,
        /**
     * Detects whether there is a link between two nodes.
     * Operation complexity is O(n) where n - number of links of a node.
     * NOTE: this function is synonim for getLink()
     *
     * @returns link if there is one. null otherwise.
     */ hasLink: getLink,
        /**
     * Detects whether there is a node with given id
     * 
     * Operation complexity is O(1)
     * NOTE: this function is synonim for getNode()
     *
     * @returns node if there is one; Falsy value otherwise.
     */ hasNode: getNode,
        /**
     * Gets an edge between two nodes.
     * Operation complexity is O(n) where n - number of links of a node.
     *
     * @param {string} fromId link start identifier
     * @param {string} toId link end identifier
     *
     * @returns link if there is one. null otherwise.
     */ getLink: getLink
    };
    // this will add `on()` and `fire()` methods.
    $5CkbI(graphPart);
    monitorSubscribers();
    return graphPart;
    function monitorSubscribers() {
        var realOn = graphPart.on;
        // replace real `on` with our temporary on, which will trigger change
        // modification monitoring:
        graphPart.on = on;
        function on() {
            // now it's time to start tracking stuff:
            graphPart.beginUpdate = enterModification = enterModificationReal;
            graphPart.endUpdate = exitModification = exitModificationReal;
            recordLinkChange = recordLinkChangeReal;
            recordNodeChange = recordNodeChangeReal;
            // this will replace current `on` method with real pub/sub from `eventify`.
            graphPart.on = realOn;
            // delegate to real `on` handler:
            return realOn.apply(graphPart, arguments);
        }
    }
    function recordLinkChangeReal(link, changeType) {
        changes.push({
            link: link,
            changeType: changeType
        });
    }
    function recordNodeChangeReal(node, changeType) {
        changes.push({
            node: node,
            changeType: changeType
        });
    }
    function addNode(nodeId, data) {
        if (nodeId === undefined) throw new Error('Invalid node identifier');
        enterModification();
        var node = getNode(nodeId);
        if (!node) {
            node = new $eae549276f7353b3$var$Node(nodeId, data);
            recordNodeChange(node, 'add');
        } else {
            node.data = data;
            recordNodeChange(node, 'update');
        }
        nodes.set(nodeId, node);
        exitModification();
        return node;
    }
    function getNode(nodeId) {
        return nodes.get(nodeId);
    }
    function removeNode(nodeId) {
        var node = getNode(nodeId);
        if (!node) return false;
        enterModification();
        var prevLinks = node.links;
        if (prevLinks) {
            node.links = null;
            for(var i = 0; i < prevLinks.length; ++i)removeLink(prevLinks[i]);
        }
        nodes.delete(nodeId);
        recordNodeChange(node, 'remove');
        exitModification();
        return true;
    }
    function addLink(fromId, toId, data) {
        enterModification();
        var fromNode = getNode(fromId) || addNode(fromId);
        var toNode = getNode(toId) || addNode(toId);
        var link = createLink(fromId, toId, data);
        links.push(link);
        // TODO: this is not cool. On large graphs potentially would consume more memory.
        $eae549276f7353b3$var$addLinkToNode(fromNode, link);
        if (fromId !== toId) // make sure we are not duplicating links for self-loops
        $eae549276f7353b3$var$addLinkToNode(toNode, link);
        recordLinkChange(link, 'add');
        exitModification();
        return link;
    }
    function createSingleLink(fromId, toId, data) {
        var linkId = $eae549276f7353b3$var$makeLinkId(fromId, toId);
        return new $eae549276f7353b3$var$Link(fromId, toId, data, linkId);
    }
    function createUniqueLink(fromId, toId, data) {
        // TODO: Get rid of this method.
        var linkId = $eae549276f7353b3$var$makeLinkId(fromId, toId);
        var isMultiEdge = multiEdges.hasOwnProperty(linkId);
        if (isMultiEdge || getLink(fromId, toId)) {
            if (!isMultiEdge) multiEdges[linkId] = 0;
            var suffix = '@' + ++multiEdges[linkId];
            linkId = $eae549276f7353b3$var$makeLinkId(fromId + suffix, toId + suffix);
        }
        return new $eae549276f7353b3$var$Link(fromId, toId, data, linkId);
    }
    function getNodeCount() {
        return nodes.size;
    }
    function getLinkCount() {
        return links.length;
    }
    function getLinks(nodeId) {
        var node = getNode(nodeId);
        return node ? node.links : null;
    }
    function removeLink(link) {
        if (!link) return false;
        var idx = $eae549276f7353b3$var$indexOfElementInArray(link, links);
        if (idx < 0) return false;
        enterModification();
        links.splice(idx, 1);
        var fromNode = getNode(link.fromId);
        var toNode = getNode(link.toId);
        if (fromNode) {
            idx = $eae549276f7353b3$var$indexOfElementInArray(link, fromNode.links);
            if (idx >= 0) fromNode.links.splice(idx, 1);
        }
        if (toNode) {
            idx = $eae549276f7353b3$var$indexOfElementInArray(link, toNode.links);
            if (idx >= 0) toNode.links.splice(idx, 1);
        }
        recordLinkChange(link, 'remove');
        exitModification();
        return true;
    }
    function getLink(fromNodeId, toNodeId) {
        // TODO: Use sorted links to speed this up
        var node = getNode(fromNodeId), i;
        if (!node || !node.links) return null;
        for(i = 0; i < node.links.length; ++i){
            var link = node.links[i];
            if (link.fromId === fromNodeId && link.toId === toNodeId) return link;
        }
        return null; // no link.
    }
    function clear() {
        enterModification();
        forEachNode(function(node) {
            removeNode(node.id);
        });
        exitModification();
    }
    function forEachLink(callback) {
        var i, length;
        if (typeof callback === 'function') for(i = 0, length = links.length; i < length; ++i)callback(links[i]);
    }
    function forEachLinkedNode(nodeId, callback, oriented) {
        var node = getNode(nodeId);
        if (node && node.links && typeof callback === 'function') {
            if (oriented) return forEachOrientedLink(node.links, nodeId, callback);
            else return forEachNonOrientedLink(node.links, nodeId, callback);
        }
    }
    function forEachNonOrientedLink(links, nodeId, callback) {
        var quitFast;
        for(var i = 0; i < links.length; ++i){
            var link = links[i];
            var linkedNodeId = link.fromId === nodeId ? link.toId : link.fromId;
            quitFast = callback(nodes.get(linkedNodeId), link);
            if (quitFast) return true; // Client does not need more iterations. Break now.
        }
    }
    function forEachOrientedLink(links, nodeId, callback) {
        var quitFast;
        for(var i = 0; i < links.length; ++i){
            var link = links[i];
            if (link.fromId === nodeId) {
                quitFast = callback(nodes.get(link.toId), link);
                if (quitFast) return true; // Client does not need more iterations. Break now.
            }
        }
    }
    // we will not fire anything until users of this library explicitly call `on()`
    // method.
    function noop() {}
    // Enter, Exit modification allows bulk graph updates without firing events.
    function enterModificationReal() {
        suspendEvents += 1;
    }
    function exitModificationReal() {
        suspendEvents -= 1;
        if (suspendEvents === 0 && changes.length > 0) {
            graphPart.fire('changed', changes);
            changes.length = 0;
        }
    }
    function forEachNode(callback) {
        if (typeof callback !== 'function') throw new Error('Function is expected to iterate over graph nodes. You passed ' + callback);
        var valuesIterator = nodes.values();
        var nextValue = valuesIterator.next();
        while(!nextValue.done){
            if (callback(nextValue.value)) return true; // client doesn't want to proceed. Return.
            nextValue = valuesIterator.next();
        }
    }
}
// need this for old browsers. Should this be a separate module?
function $eae549276f7353b3$var$indexOfElementInArray(element, array) {
    if (!array) return -1;
    if (array.indexOf) return array.indexOf(element);
    var len = array.length, i;
    for(i = 0; i < len; i += 1){
        if (array[i] === element) return i;
    }
    return -1;
}
/**
 * Internal structure to represent node;
 */ function $eae549276f7353b3$var$Node(id, data) {
    this.id = id;
    this.links = null;
    this.data = data;
}
function $eae549276f7353b3$var$addLinkToNode(node, link) {
    if (node.links) node.links.push(link);
    else node.links = [
        link
    ];
}
/**
 * Internal structure to represent links;
 */ function $eae549276f7353b3$var$Link(fromId, toId, data, id) {
    this.fromId = fromId;
    this.toId = toId;
    this.data = data;
    this.id = id;
}
function $eae549276f7353b3$var$makeLinkId(fromId, toId) {
    return fromId.toString() + "\uD83D\uDC49 " + toId.toString();
}

});
parcelRegister("5CkbI", function(module, exports) {
module.exports = function eventify(subject) {
    $4170293e4d0e08c7$var$validateSubject(subject);
    var eventsStorage = $4170293e4d0e08c7$var$createEventsStorage(subject);
    subject.on = eventsStorage.on;
    subject.off = eventsStorage.off;
    subject.fire = eventsStorage.fire;
    return subject;
};
function $4170293e4d0e08c7$var$createEventsStorage(subject) {
    // Store all event listeners to this hash. Key is event name, value is array
    // of callback records.
    //
    // A callback record consists of callback function and its optional context:
    // { 'eventName' => [{callback: function, ctx: object}] }
    var registeredEvents = Object.create(null);
    return {
        on: function on(eventName, callback, ctx) {
            if (typeof callback !== 'function') throw new Error('callback is expected to be a function');
            var handlers = registeredEvents[eventName];
            if (!handlers) handlers = registeredEvents[eventName] = [];
            handlers.push({
                callback: callback,
                ctx: ctx
            });
            return subject;
        },
        off: function off(eventName, callback) {
            var wantToRemoveAll = typeof eventName === 'undefined';
            if (wantToRemoveAll) {
                // Killing old events storage should be enough in this case:
                registeredEvents = Object.create(null);
                return subject;
            }
            if (registeredEvents[eventName]) {
                var deleteAllCallbacksForEvent = typeof callback !== 'function';
                if (deleteAllCallbacksForEvent) delete registeredEvents[eventName];
                else {
                    var callbacks = registeredEvents[eventName];
                    for(var i = 0; i < callbacks.length; ++i)if (callbacks[i].callback === callback) callbacks.splice(i, 1);
                }
            }
            return subject;
        },
        fire: function fire(eventName) {
            var callbacks = registeredEvents[eventName];
            if (!callbacks) return subject;
            var fireArguments;
            if (arguments.length > 1) fireArguments = Array.prototype.splice.call(arguments, 1);
            for(var i = 0; i < callbacks.length; ++i){
                var callbackInfo = callbacks[i];
                callbackInfo.callback.apply(callbackInfo.ctx, fireArguments);
            }
            return subject;
        }
    };
}
function $4170293e4d0e08c7$var$validateSubject(subject) {
    if (!subject) throw new Error('Eventify cannot use falsy object as events subject');
    var reservedWords = [
        'on',
        'fire',
        'off'
    ];
    for(var i = 0; i < reservedWords.length; ++i){
        if (subject.hasOwnProperty(reservedWords[i])) throw new Error("Subject cannot be eventified, since it already has property '" + reservedWords[i] + "'");
    }
}

});



var $af4acf025ae421fd$exports = {};
$parcel$extendImportMap({
    "cvggw": "openpgp.min.f8cf0dff.js"
});


parcelRequire("7EHRQ");
})();
//# sourceMappingURL=app.dfb09495.js.map
